/**
 * @license
 * @qwik.dev/core 2.0.0-beta.37-dev+66d1cdc
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as $e, isBrowser as ye } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as pe } from "@qwik.dev/core/preloader";

const me = !1;

const be = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const ve = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const _e = (t, n, e, s, o = !1) => {
    const r = ve(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const ge = (t, n, e) => {
    const s = ve(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ee = (t, n, e) => ve(t, n, e) >= 0;

const Se = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ke = t => typeof t === "object" && t !== null;

const Re = t => Array.isArray(t);

const Pe = t => typeof t === "string";

const Te = t => typeof t === "function";

const qe = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = be(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Me = "<sync>";

const Ae = t => typeof t === "function" && typeof t.getSymbol === "function";

const Rh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const xe = "q:type";

const Ie = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Oe = 124;

const je = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Le = "q:renderFn";

const Fe = "q:targetEl";

const Xe = "⚡️";

const De = "q:slot";

const We = "q:s";

const Ve = "[q\\:patch]";

const Ph = "q:r";

const Th = "q:rp";

const Ue = "q:style";

const ze = "style[q\\:style]";

const Be = ze + ",style[q\\:sstyle]";

const He = "q:sstyle";

const Je = "q:ctx";

const Qe = "q:brefs";

const Ye = (t, n) => t["qFuncs_" + n] || [];

const Ge = "q:base";

const Ke = "q:container-island";

const Ze = "/" + Ke;

const ts = "q:ignore";

const ns = "/" + ts;

const es = "q:container";

const ss = "/" + es;

const rs = "q:cursorBoundary";

const is = "q:template";

const os = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const ls = "http://www.w3.org/1999/xhtml";

const us = "http://www.w3.org/2000/svg";

const cs = "http://www.w3.org/1998/Math/MathML";

const fs = "qRender";

const as = "q:id";

const hs = "q:key";

const ds = "q:props";

const ps = "q:seq";

const $s = "q:seqIdx";

const ys = "q:p";

const ms = "q:ps";

const bs = ":on";

const vs = ":onIdx";

const _s = ":onFlags";

const gs = ":nearestCursorBoundary";

const Es = ":";

const Ss = "dangerouslySetInnerHTML";

const Rs = 100;

const Ps = t => !!t && typeof t == "object" && typeof t.then === "function";

const Ts = (t, n, e) => {
    try {
        const s = t();
        return Ps(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const qs = (t, n) => Ps(t) ? t.then(n) : n(t);

const Ms = t => new Promise(n => {
    setTimeout(n, t);
});

const As = t => {
    throw t;
};

function n(t, n = As) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ps(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Rs;
    const r = async e => {
        for (;Ps(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ps(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const xs = t => Xe + t;

const Is = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + xs(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Ns = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Cs(t.slice(s, -1));
        }
    }
    return null;
}

const Cs = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Os(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Os = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const js = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Ls = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Fs = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Xs = t => {
    if (!t) {
        return "";
    }
    if (Pe(t)) {
        return t.trim();
    }
    const n = [];
    if (Re(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Xs(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Ds = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function s(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Xs(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (Re(t)) {
                    throw qe(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Ds(e) + ":" + Ws(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ws = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Ls.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Vs = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Us = () => ({
    isServer: $e,
    importSymbol(t, n, e) {
        if ($e) {
            const t = Rh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw qe(6, [ e ]);
        }
        if (!n) {
            throw qe(14, [ e ]);
        }
        if (!t) {
            throw qe(13, [ n, e ]);
        }
        const s = zs(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const zs = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Ge) ?? s, s);
    return new URL(e, o);
};

let Bs = /*#__PURE__ */ Us();

const Hs = t => Bs = t;

const Js = () => Bs;

const qh = () => Bs.isServer;

const Mh = typeof document !== "undefined";

const Qs = !$e && Mh;

const Ys = Qs ? document : void 0;

const Gs = Qs && Ys.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Ks = /\.[mc]?js$/;

const Zs = 1e3 / 60;

const tr = t => {
    let n = nr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Wt: t,
            Ot: Ks.test(t) ? 0 : 3,
            Vt: n,
            Ut: 1,
            zt: performance.now(),
            Bt: 0,
            Ht: 0
        }))(t, e);
        nr.set(t, n);
    }
    return n;
};

const nr = new Map;

let er = 0;

const sr = [];

const rr = Vs(function Ih() {
    or = !1;
    if (!sr.length) {
        return;
    }
    const t = performance.now() + Zs;
    let n = !1;
    for (;sr.length; ) {
        const e = sr[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || er < 25)) {
            break;
        }
        sr.shift();
        ar(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && sr.length && !or) {
        or = !0;
        rr();
    }
});

const ir = Vs(r);

let or = !1;

let lr = !1;

let ur = !1;

const cr = [];

const fr = () => {
    const t = cr[cr.length - 1];
    const n = t.Jt;
    if (t.Vt) {
        const e = t.Qt;
        if (e >= t.Vt.length) {
            cr.pop();
            return !1;
        }
        const s = t.Vt[e];
        t.Qt = e + 1;
        const o = tr(s.Wt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Yt);
        } else {
            const t = 1 - s.Yt * r;
            const n = s.Gt;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Gt = e;
        }
        cr.push({
            Jt: o,
            Ut: i,
            Kt: t.Kt
        });
        return !0;
    }
    if (t.Kt?.has(n)) {
        cr.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        cr.pop();
        return !1;
    }
    if (n.Vt?.length) {
        const e = t.Kt || new Set;
        e.add(n);
        t.Kt = e;
        t.Vt = n.Vt;
        t.Qt = 0;
        return !1;
    }
    cr.pop();
    return !1;
};

function r() {
    if (ur || !cr.length) {
        return;
    }
    lr = !1;
    ur = !0;
    const t = Qs ? performance.now() + Zs : 0;
    let n = !1;
    for (;cr.length; ) {
        n = !0;
        const e = fr();
        if (Qs && e && performance.now() >= t) {
            if (!lr) {
                lr = !0;
                ir();
            }
            break;
        }
    }
    ur = !1;
    n && Qs && rr();
}

const ar = t => {
    if (t.Ot >= 2) {
        return;
    }
    er++;
    const n = performance.now();
    t.Bt = n - t.zt;
    t.Ot = 2;
    const e = Ys.createElement("link");
    e.href = new URL("undefined" + t.Wt, Ys.baseURI).toString();
    e.rel = Gs;
    e.as = "script";
    e.onload = e.onerror = () => {
        er--;
        const s = performance.now();
        t.Ht = s - n;
        t.Ot = 4;
        e.remove();
        rr();
    };
    Ys.head.appendChild(e);
};

const hr = (t, n) => {
    const e = tr(t);
    e && ((t, n) => {
        cr.unshift({
            Jt: t,
            Ut: n,
            Kt: void 0
        });
    })(e, n);
};

Qs && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    hr(e, 0);
                }
            } else {
                hr(t, 0);
            }
            Qs ? ir() : r();
        })(t);
    }
});

const dr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const pr = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    }
});

const $r = '"';

const yr = "[";

const mr = "]";

const wr = ",";

const br = "2.0.0-beta.37-dev+66d1cdc";

const vr = t => t.nodeType === 1;

const Ah = t => t.Cn;

const _r = Symbol();

class gr {
    [_r]=void 0;
}

const Er = t => t === "foreignObject";

const Sr = t => t === "svg" || Er(t);

const kr = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Es && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const Rr = {
    elementNamespace: ls,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!kl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Er(kl(t));
    let o = ls;
    let r = 0;
    const i = typeof n === "string" || Ho(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Sr(t);
        }
        if (Ho(t)) {
            return Sr(kl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = us;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return kr(t);
        }
        if (Ho(t)) {
            return kr(kl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = cs;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? us : e ? cs : ls;
        r = t.flags & 1536;
    }
    Rr.elementNamespace = o;
    Rr.elementNamespaceFlag = r;
    return Rr;
}

class Pr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [_r]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Tr extends Pr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class qr extends Tr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Mr extends Pr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Ar = [];

const xr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Ar.length;
    for (let t = 0; t < Ar.length; t++) {
        const n = y(Ar[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Ar.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Ar.length; t++) {
        const n = Ar[t];
        let e = !1;
        for (let t = 0; t < xr.length; t++) {
            const s = xr[t];
            if (Hl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    xr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Ar.indexOf(t);
    if (s !== -1) {
        Ar.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = xr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = xr.length - 1;
    e !== s && (xr[e] = xr[s]);
    xr.pop();
    n.o--;
    return !0;
}

const Ir = new WeakMap;

const Nr = ":nodeProps";

const Cr = ":nodeDiff";

const Or = ":errorData";

const jr = ":signal";

const Lr = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && cn(e) && function s(t, n, e) {
        h(e, t);
        const s = y(e);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return Ir.get(t) ?? null;
}

const Fr = Symbol();

class Xr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Dr = Symbol();

const Wr = Symbol();

const Vr = Symbol();

function m(t, n, e) {
    t[_r] || ($e && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Qe, new Map) : t[_r] = new Map);
    const o = t[_r];
    let r = o.get(n);
    if (!r) {
        r = new Xr(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ur = (t, n) => (e, s) => {
    const o = he();
    o.Ft = m(t, ":");
    o.$ = n || void 0;
    return ce(o, () => {
        if (Te(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (lu(e)) {
            return e.value;
        }
        if (ke(e) && gu(e)) {
            qn(wu(e), Vr, mu(e), o.Ft);
            return e;
        }
        throw qe(2);
    });
};

class zr {
    Zt;
    ct=void 0;
    $=null;
    tn=null;
    constructor(t, n) {
        this.$ = t || rf()?.$ || null;
        this.Zt = n;
    }
    trigger() {
        hu(this.$, this, this.ct);
    }
    force() {
        hu(this.$, this, this.ct);
    }
    get untrackedValue() {
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = rf();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ft;
        if (e) {
            const t = $e;
            const s = this.ct ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            uu(s, e);
            cu(e, this);
            if (t) {
                const t = au(n.$, this.$);
                o && t?.nn?.(this, e, null);
                fu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Zt) {
            this.Zt = t;
            hu(this.$, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Zt
        };
    }
}

class Br extends zr {
    en;
    h;
    [_r]=void 0;
    constructor(t, n, e = 17) {
        super(t || rf()?.$, Fr);
        this.en = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = he();
        t.$ = this.$ || void 0;
        const e = n(fe.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.en;
        ou(t);
        const n = rf();
        const e = n?.Ft;
        if (n) {
            const t = m(this, ".");
            gn(this.$, t);
            n.Ft = t;
        }
        try {
            const e = t.getFn(n)();
            if (Ps(e)) {
                throw qe(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ft = e);
        }
    }
}

class Hr {
    sn;
    rn=null;
    ln=!1;
    un=!0;
    constructor(t, n, e) {
        this.sn = t;
        if (n !== void 0) {
            this.info = n;
            this.cn = e;
        }
    }
    get track() {
        return this.fn ||= Ur(this.sn, this.sn.$);
    }
    get abortSignal() {
        return (this.an ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.sn.Zt;
        if (t !== Fr) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.hn ||= []).push(t);
    }
}

class Jr extends Br {
    dn=!1;
    pn=void 0;
    $n=null;
    [_r]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Zt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.yn = r;
            this.mn = [];
        }
        const i = s.timeout;
        i && (this.wn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.$n?.rn) {
            if (this.Zt === Fr || $e) {
                throw this.$n?.rn;
            }
            return this.Zt;
        }
        if (this.pn) {
            throw this.pn;
        }
        if ($e && this.h & 64 && this.Zt === Fr) {
            throw qe(35);
        }
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.bn = void 0;
        if (this.mn) {
            for (let t = 0; t < this.mn.length; t++) {
                this.mn[t].un = !1;
            }
        } else {
            this.$n && (this.$n.un = !1);
        }
        this.vn();
        super.value = t;
        this._n();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = rf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                uu(this.$t ||= new Set, t);
                cu(t, this);
                fu(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.dn) {
            this.dn = t;
            hu(this.$, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if ($e && this.$n?.rn) {
            throw this.$n?.rn;
        }
        return this.dn;
    }
    get error() {
        const t = this.untrackedError;
        const n = rf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                uu(this.yt ||= new Set, t);
                cu(t, this);
                fu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.pn) {
            this.pn = t;
            hu(this.$, this, this.yt);
        }
    }
    get untrackedError() {
        return this.pn;
    }
    get expires() {
        return this.Pt || 0;
    }
    set expires(t) {
        this.vn();
        this.Pt = t;
        this.Pt && this.gn() && this._n();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Pt && this.gn()) {
            this.vn();
            this._n();
        }
    }
    get interval() {
        const t = this.Pt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.bn = t;
            this.cn = this.cn === void 0 ? 1 : this.cn + 1;
        }
        this.En(!0, this.h & 128);
    }
    En(t, n) {
        this.h |= 1;
        this.vn();
        n && (this.Zt = Fr);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.$n && this.Sn(this.$n, t);
    }
    wt() {
        if (!(this.h & 32) || this.gn()) {
            return;
        }
        if (!ye) {
            return;
        }
        setTimeout(() => {
            this.gn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.$n?.rn; ) {
            await (this.$n?.rn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if ($e && this.h & 64) {
            this.dn = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.vn();
        this.h &= -2;
        const t = this.$n;
        t && this.Sn(t);
        const n = this.yn === 0 ? Infinity : this.yn ?? 1;
        if (this.mn ? this.mn.length >= n : t?.rn) {
            this.h |= 1;
            return;
        }
        const e = this.cn;
        const s = new Hr(this, this.bn, e);
        this.$n = s;
        this.mn && this.mn.push(s);
        s.rn = this.kn(s);
    }
    async kn(t) {
        let e = this.en.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.en.resolve();
            if (t.an?.signal.aborted) {
                t.rn = null;
                return;
            }
        }
        try {
            this.wn && (this.Rn = setTimeout(() => {
                const n = Error(`timeout ${this.wn}ms`);
                this.Pn(t, n);
                t.an?.abort(n);
            }, this.wn));
            const s = n(e.bind(null, t));
            let o;
            if (Ps(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.rn = null;
            if (t.un) {
                const n = this.mn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].un = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.rn = null;
            this.Pn(t, n);
        }
        if ((() => t === this.$n)()) {
            clearTimeout(this.Rn);
            t.cn === this.cn && (this.bn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this._n();
            }
        }
    }
    Pn(t, n) {
        if (t !== this.$n || !t.un) {
            return;
        }
        t.un = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Fr;
    }
    async Tn() {
        this.vn();
        clearTimeout(this.Rn);
        const t = this.$n;
        t && this.Sn(t);
        this.mn ? await Promise.all(this.mn.map(t => t.rn)) : await (t?.rn);
    }
    vn() {
        if (this.qn !== void 0) {
            clearTimeout(this.qn);
            this.qn = void 0;
        }
    }
    _n() {
        if ($e || !this.Pt) {
            return;
        }
        this.vn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.qn = setTimeout(() => this.En(t, n), this.Pt);
        this.qn?.unref?.();
    }
    gn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    Sn(t, n) {
        if (t.ln) {
            return;
        }
        t.ln = !0;
        t.an?.abort(n);
        t.rn = qs(t.rn, () => this.Mn(t));
    }
    Mn(t) {
        const n = t.hn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.rn = null;
            n && (n.length = 0);
            const e = this.mn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    Ps(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Qr = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Yr = Symbol();

const Gr = Symbol();

const Kr = Symbol();

const Zr = Symbol();

const ti = Symbol();

const ni = Symbol();

const ei = [];

const si = {};

Object.freeze(ei);

Object.freeze(si);

function w(t) {
    return new Proxy({}, new ri(t));
}

class ri {
    owner;
    ct=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Yr) {
            return this.owner.constProps;
        }
        if (n === Gr) {
            return this.owner.varProps;
        }
        if (n === Kr) {
            return this.owner;
        }
        if (n === Zr) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = li(this.owner, n);
            n in this.owner.varProps && ii(this, n);
        }
        return s instanceof Pi && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Kr) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Yr) {
            this.owner.constProps = s;
        } else if (n === Gr) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === si ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                oi(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && oi(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Yr || n === Gr) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && ii(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ii = (t, n) => {
    const e = rf();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ft;
    s && qn(t.owner._proxy, n, t, s);
};

const oi = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && hu(t.$, t, e);
    return !!e;
};

const li = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const ui = (t, n) => ci(t)?.[n] || fi(t)?.[n] || null;

const ci = t => {
    if (!t) {
        return null;
    }
    return Gr in t ? "children" in t ? {
        ...t[Gr],
        children: t.children
    } : t[Gr] : t;
};

const fi = t => {
    if (!t) {
        return null;
    }
    return Yr in t ? t[Yr] : null;
};

const ai = t => t && Gr in t;

const hi = t => (n, ...e) => t.call(null, Xf(n), ...e);

class di extends Br {
    constructor(t, n) {
        super(t, n, 17);
    }
    An=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        ou(this.en);
        const t = cf(this.en.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Zt === Fr ? e : this.Zt;
        const r = af(() => this.An ? s?.(o) || o : n(o), this, ".", this.$);
        this.An = !0;
        this.h &= -2;
        const i = this.An && r !== "undefined" || r !== this.Zt;
        if (i) {
            this.Zt = r;
            hu(this.$, this, this.ct);
        }
    }
}

const pi = (t, n) => new Br(n?.container || null, t, pu(n?.serializationStrategy || "always"));

const $i = (t, n) => new Jr(n?.container || null, t, pu(n?.serializationStrategy || "always"), n);

const yi = t => new di(null, t);

const mi = t => new zr(null, t);

const wi = /*#__PURE__*/ hi(pi);

const bi = /*#__PURE__*/ hi($i);

const vi = hi(yi);

const _i = t => t.value;

const gi = (t, n) => t[n];

const Ei = t => {
    if (t.length === 1) {
        if (lu(t[0])) {
            return t[0].tn ||= new Pi(null, _i, t, null);
        }
        if (gu(t[0])) {
            return new Pi(null, _i, t, null);
        }
        return t[0].value;
    }
    return new Pi(null, gi, t, null);
};

const Si = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ke(n)) {
        return n[e];
    }
    if (lu(n)) {
        if (n instanceof Pi && n.h & 4) {
            return n;
        }
        return Ei(t);
    }
    if (ai(n)) {
        const s = n[Yr];
        const o = n[Gr];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return ki(n, t);
        }
    } else {
        const s = wu(n);
        if (s) {
            const n = s[e];
            return ki(n, t);
        }
    }
    return n[e];
};

const ki = (t, n) => lu(t) ? t : Ei(n);

const Ri = (t, n) => {
    const e = Si(t, n);
    if (e === ti) {
        return t[n];
    }
    return e;
};

class Pi extends zr {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [_r]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Fr);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, jr, this);
                hn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            hu(this.$, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = af(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Zt;
        if (n) {
            this.h |= 2;
            this.Zt = t;
        }
    }
    rt() {
        return this.ot === _i && lu(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw qe(31);
    }
    get value() {
        return super.value;
    }
}

class Ti {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class qi {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || dr(n) ? si : n;
        this.constProps = !e || dr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const Mi = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ai = t => t instanceof qi;

const xi = (t, n) => {
    if (typeof t === "string") {
        const e = se(n);
        Pf(Tf(e, t));
    }
    return null;
};

function b(t, n) {
    xi(this, n);
    const e = Rf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    xi(this, n);
    const e = Rf[0];
    e.value = n.checked;
}

function _(t, n) {
    xi(this, n);
    if (Rf) {
        for (let t = 0; t < Rf.length; t++) {
            const n = Rf[t];
            n instanceof Jr && n.h & 64 && n.p();
        }
    }
}

const Ii = "bind:value";

const Ni = "bind:checked";

const Ci = "passive:";

const Oi = "preventdefault:";

const ji = Object.prototype.hasOwnProperty;

const Li = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Cs(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Fi = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Cs(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Cs(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Cs(t.slice(11, -1));
    }
    return null;
};

const Xi = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = Fi(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Di = (t, n, e, s, o, r, i) => new qi(t, n, e, s, o, r, !1, i);

const Wi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Ci)) {
                    r.push(o);
                    t.add(Cs(o.slice(8)));
                } else {
                    o.startsWith(Oi) ? h.push(o) : Fi(o) !== null ? s.push(o) : o === Ni ? a = e[o] : o === Ii && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Ci)) {
                    i.push(s);
                    t.add(Cs(s.slice(8)));
                } else {
                    s.startsWith(Oi) ? d.push(s) : Fi(s) !== null ? o.push(s) : s === Ni ? a = n[s] : s === Ii && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Li(e, r, h, t, l);
            l = l || e !== n;
            e = Xi(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Li(n, i, d, t, u);
            u = u || n !== e;
            n = Xi(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && ji.call(n, Ni) && delete n[Ni];
                if (e && ji.call(e, Ni)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ni];
                }
                n.checked = a;
                const t = xf(null, "_chk", v, null, [ a ]);
                if (e && ji.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Mi(n, "q-e:input", t) || c;
                }
                c = Mi(n, "q-e:input", t) || c;
            } else if (f) {
                n && ji.call(n, Ii) && delete n[Ii];
                if (e && ji.call(e, Ii)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ii];
                }
                n.value = f;
                const t = xf(null, "_val", b, null, [ f ]);
                if (e && ji.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Mi(n, "q-e:input", t) || c;
                }
                c = Mi(n, "q-e:input", t) || c;
            }
        }
        if (n && ji.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && ji.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new qi(t, n, e, s, o, r, c || !0, i);
};

const Vi = (t, n, e, s) => Hi(t, n, s);

const Ui = (t, n, e, s, o) => Hi(t, {
    ...e,
    ...n
}, o);

const zi = (t, n, e, s, o, r) => Hi(t, {
    ...e,
    ...n,
    children: s
}, r);

const Bi = t => t.children;

const Hi = (t, n, e, s, o) => Wi(t, n, null, null, 0, e, o);

const Ji = Hi;

const Qi = Hi;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Wi(t, n, null, s.children, 0, o);
}

const Yi = t => t.children;

const Gi = (t, n) => new qi(Bi, null, null, t.children, 0, n);

const Ki = t => Di(Bi, null, {
    [We]: ""
}, t.children, 0, t.name ?? "");

const Zi = Symbol();

const to = () => null;

const no = () => null;

const eo = t => t.children;

const so = (t, n) => Hi(Gi, {
    children: Hi(ro, t)
}, n);

const ro = () => null;

let io = null;

let oo = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    oo || (oo = t.setAttributeNS);
                    oo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            io || (io = t.setAttribute);
            io.call(t, n, e);
        })(t, n, e);
    }
}

const lo = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const uo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Yr];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Gr];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new qi(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && lo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Pi) {
            return hf(n, t, ":", e);
        }
    }
    return li(n, "name") || "";
}

class co {
    target;
    constructor(t) {
        this.target = t;
    }
}

class fo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class ao {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class ho {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class po {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const $o = t => new co(t);

const yo = t => new fo(t);

const mo = (t, n) => new ao(t, n);

const wo = (t, n, e) => new ho(t, n, e);

const bo = (t, n, e, s = null, o = !1) => new po(t, n, e, s, o);

const vo = () => {
    const t = lf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, ps);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, ps, s);
    }
    let o = t.$.getHostProp(e, $s);
    o === null && (o = 0);
    t.$.setHostProp(e, $s, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const _o = t => {
    const n = Te(t) && !Bf(t) ? ce(void 0, t) : t;
    return mi(n);
};

const go = t => Eo(_o, t);

const Eo = (t, ...n) => {
    const {val: e, set: s} = vo();
    if (e != null) {
        return e;
    }
    t = Te(t) && !Bf(t) ? cf(t, ...n) : t;
    return s(t);
};

const So = () => ({
    pending: mi(0),
    version: mi(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, rs);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    tl(t, gs, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Zo(t, gs, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && tl(t, gs, n);
}

function A(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        A(t, o, P(t, o) || e);
    }
}

const ko = t => {
    if (t.Tn) {
        try {
            t.Tn();
        } catch (t) {
            ((t, ...n) => {
                be(!1, t, ...n);
            })(t);
        }
        t.Tn = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = uf(e, s));
    const r = o.$;
    const i = o.m;
    sl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Zo(i, ys, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Zo(i, ms, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return fe(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = uf(t, n);
    typeof this === "string" && Pf(Tf(e.$, this));
    const s = Rf[0];
    return x(s, t, n, e);
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Ro = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    tl(n, e, r);
    dn(t, bo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        q: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Ti({
                O: s,
                et: !0
            }),
            st: new Ti({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.st.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Po = (t, n, e, s, o, r, i) => X(F(i, t, n, o, r), e, s);

const To = (t, n, e, s, o, r, i, c, l = !1, u) => X(F(u, t, n, i, c), e, s, o, r, l);

function X(t, n, e, s = Tl(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (Ps(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function D(t, n, e, s = Tl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.D = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Ai(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Ro.call(t.J.constProps, Ss) || Ro.call(t.J.varProps, Ss);
                            e ? t.D || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Yi) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === Ki) {
                                nt(t);
                                Q(t) || U(t, t.J.children, !0);
                            } else if (n === vt) {
                                J(t);
                                U(t, t.J.children, !0, !1);
                            } else if (n === no) {
                                tt(t);
                            } else if (n === to) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (lu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof Pi ? t.J.rt() : t.J;
                        const e = t.q?.[_r]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Pi && (s = Tt(e, n));
                        if (!s) {
                            const e = t.D || t.q;
                            U(t, W(t, () => hf(n, e, ".", t.$)), !0);
                        }
                    } else if (Ps(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.D || t.q);
                    }
                } else {
                    t.J === Zi || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ps(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.q);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.D !== null ? t.D = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !0) {
    if (s && (n == null || e && Re(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = t.Z || !!t.D || !Tl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.q;
        t.q = Tl(t.k);
        t.D = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    V(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.D, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function H(t) {
    if (t.D) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function J(t) {
    const n = t.J;
    const e = n.key;
    t.q = Zo(t.k, e, n => ll(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.D = zo();
        tl(t.D, De, e);
        t.D.slotParent = t.k;
        tl(t.k, e, t.D);
    }
}

function Q(t) {
    const n = t.J;
    const e = nu(t.k);
    const s = k(e, n, t.$);
    const o = li(n, rs) || null;
    const r = e ? Zo(e, s, null) : null;
    if (r == null) {
        t.D = zo();
        tl(t.D, De, s);
        tl(t.D, rs, o);
        A(t.$, t.D, o);
        e && tl(e, s, t.D);
        vl(t.M, t.k, t.D, H(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.D = r;
        tl(t.D, De, s);
        tl(t.D, rs, o);
        A(t.$, t.D, o);
        e && tl(e, s, t.D);
        bl(t.M, t.D);
        vl(t.M, t.k, t.D, H(t));
        n && Ho(n) && !n.firstChild && kl(n) === is && El(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            El(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Ps(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Tl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        Sl(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                El(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && Yo(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        El(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (lu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw qe(15, [ e ]);
}

function st(t, e, s, o, r) {
    return n(() => hf(o, e, s, t, r));
}

function rt(t, n, e, o, r) {
    const i = t.O;
    const c = o.then(t => E(n, e, s(e, t, i), r));
    t.X.push(c);
}

function it(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(es, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, r) {
    const i = function c(t, n) {
        const e = gl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = Wo(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (Ns(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, r)) {
                continue;
            }
            lu(o) && (o = st(t.$, t.D, n, o, t.tt.nt));
            if (Ps(o)) {
                rt(t, i, n, o, u);
                continue;
            }
            if (n === Ss) {
                it(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            E(i, n, s(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = Ro.call(n.varProps, "class") || n.constProps && Ro.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    pl(t.M, t.k, t.D, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && nl(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && Ho(t.q);
        const o = s && e === kl(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.q;
    s && function r(t, n, e, s) {
        t.Z || sl(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && Ro.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof Pi && e instanceof Pi && Pt(i, e)) {
                        continue;
                    }
                    qo(t, n, r, i, s);
                }
            } else {
                i != null && qo(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                Ro.call(e, r) || r.charAt(0) === ":" || Ns(r) || qo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const qo = (t, n, e, s, o) => {
    if (Ns(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === ys || e === ms) {
        tl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[_r]?.get(e);
    if (lu(s)) {
        const o = s instanceof Pi ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && gn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.tt.st);
    } else {
        i && gn(t.$, i);
    }
    if (Ps(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = Ho(o) ? kl(o) : null;
                const r = wt(o) || bt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = Ho(i) ? kl(i) : null;
                const r = wt(i) || bt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = Ho(t.q) ? kl(t.q) : null;
                    const e = wt(t.q) || bt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = Ho(s) ? kl(s) : null;
                const e = wt(s) || bt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || vl(t.M, o, t.D, C(t));
        t.q = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || bt(t.q, t.$._);
                if (n != null) {
                    const e = Ho(t.q) ? kl(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && vl(t.M, o, n, C(t));
            t.q = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && Go(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        $l(t.M, t.k, t.D = zo(), H(t));
        t.D.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        $l(t.M, t.k, t.D = zo(), H(t));
        t.D.key = e;
    }
}

function pt(t, n) {
    const e = n[zf];
    let s = t.D || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = bt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.q;
        }
        if (s) {
            const e = Zo(s, ds, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[Yr], e[Yr], e[Zr], s, !1);
                        o ||= t;
                        const r = _t(n[Gr], e[Gr], e[Zr], s, !0);
                        o ||= r;
                        e[Kr] = n[Kr];
                    } else if (n) {
                        tl(t, ds, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                tl(s, Le, i);
                s.flags &= -33;
                hn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new qi(vt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            _e(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ai(n) && li(n, De) || "") + "";
                const i = ve(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = bt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.D;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.D || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!Go(e) || Zo(e, Le, null) === null); ) {
                e = e.parent || nu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Lr] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            hn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && _n(t.$, n);
    $l(t.M, t.k, t.D = zo(), H(t));
    const o = t.J;
    tl(t.D, Le, e);
    tl(t.D, ds, s);
    t.D.key = o.key;
}

function yt(t) {
    $l(t.M, t.k, t.D = zo(), H(t));
    const n = t.J;
    tl(t.D, ds, n.props);
    n.key && (t.D.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = Zl(t.q);
        if (e === 3) {
            if (n !== Rl(t.q)) {
                Pl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    pl(t.M, t.k, t.D = Uo(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || Yo(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || Yo(t)) {
        return null;
    }
    const e = Zo(t, Le, n);
    return e ? e.it : null;
}

function vt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Qe) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = oi(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Qe) {
                continue;
            }
            if ((!t || !Ro.call(t, s)) && o) {
                delete n[s];
                const t = oi(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return dr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && cn(s) ? y(s) : null;
    if (Yo(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && cn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            _n(t, o);
            Rt(o);
            const r = c & 2 && Zo(o, Le, null) !== null;
            if (r) {
                const e = t.getHostProp(o, ps);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ke(r)) {
                            const n = iu(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                hn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof zr || gu(r)) && _n(t, r);
                            (n || r instanceof Jr) && ko(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? ll(t.rootVNode, e) : e;
                                let c = Tl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = Ko(o);
            if (i) {
                if (o === e) {
                    const n = Tl(o);
                    if (n) {
                        yn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Tl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, De);
    e != null && t.getHostProp(n.slotParent, e) === n && tl(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && kl(s) === is) {
            St(t, e);
            El(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function Tt(t, n) {
    if (!(n instanceof Pi)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Pi && Pt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Mo = (t, n, e, s, o) => {
    const r = ae(t.jt, n, t);
    if (e) {
        r.Ft = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Le));
    if (Ae(s)) {
        o = o || t.getHostProp(n, ds) || si;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Bf(s)) {
        const t = s;
        i = () => fe(r, t, [ o || si, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => fe(r, t, [ o || si ]);
    }
    const l = $e;
    const u = (e = 0) => Ts(() => {
        if (!c) {
            t.setHostProp(n, $s, null);
            t.setHostProp(n, vs, null);
        }
        e > 0 && Bo(n) && _n(t, n);
        return qs(i(o), t => qs(r.Xt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Rs) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, bs);
        if (o) {
            return function r(t, n, e) {
                const s = xt(n);
                let o = n;
                const r = "q-e:qvisible";
                return qs(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Nt();
                                    const n = $e;
                                    n && t.ut(i) || (o = It(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Mt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Ps(t) && e < Rs) {
            return t.then(() => u(++e));
        }
        if (e >= Rs) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Mt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = js(n);
    c && At(t, f, "capture");
    l && At(t, f, "preventdefault");
    u && At(t, f, "stoppropagation");
}

function At(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === si && (t.varProps = {});
    t.varProps[s] = !0;
}

function xt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ai(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Re(t)) {
            n.push(...t);
        } else {
            if (Ps(t)) {
                return qs(t, t => xt(t));
            }
            if (lu(t)) {
                return xt(t.untrackedValue);
            }
        }
    }
    return null;
}

function It(t, n) {
    if (Ai(t)) {
        if (t.type !== Yi && !Bf(t.type)) {
            return Di(Yi, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Re(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return Di(Yi, null, null, [ t, n ], 0, null);
    }
    if (Re(t) && t.length > 0) {
        It(t[0], n);
        return t;
    }
    return t;
}

function Nt() {
    return new qi("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ct(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Ot(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ct(t[c], c, r, s);
    }
    return i;
}

function jt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Lt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Tl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return To(c, n, Ot(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Sl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return To(c, n, Ot(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Sl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            El(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return To(c, n, Ot(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            El(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let I = m;
    const A = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                I = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || vl(n, e, t, I);
                I = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = To(c, n, Ot(o, a, null, i, l, M), e, I, I, s, null, !0, f);
            return qs(d, () => {
                const t = jt(e, I, u);
                I = t;
                M = l - 1;
                return A();
            });
        }
    };
    return A();
}

function Ft(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, ps);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof ru) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = su(s, n, t);
                Ps(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Xt(t, n) {
    const e = t.props ||= {};
    e[Cr] = n;
}

function Dt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Or] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Or] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = hl(n, document, r, e);
    const u = Ho(r) && i || r;
    const f = u === r ? null : c;
    pl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Wt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Cr];
    }(t);
    if (!r) {
        return;
    }
    Xt(t, null);
    lu(r) && (r = r.value);
    return Po(n, e, r, o, s, null);
}

function Vt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, Le);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, ds) || null;
    return zt(n, o, o, r, i, e, s);
}

function Ut(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Lr] || null;
        e && delete n[Lr];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return zt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function zt(t, e, s, o, r, i, c) {
    const l = Ts(() => Mo(t, e, s, o, r), s => {
        const o = t.getHostProp(e, He);
        return n(() => Po(t, i, s, e, c, Is(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Ps(l)) {
        return l;
    }
    return;
}

function Bt(t, n, e, s, o, r = null) {
    n.push(bo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Ht(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Nr] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        lu(e) && (e = e.value);
        const r = s.isConst;
        Bt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Nr];
    })(t);
}

function Jt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, ps);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof ru && n.h & 16) {
            n.h &= -17;
            const t = n;
            ko(t);
        }
    }
}

function Qt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, jr);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = he();
    r.$ = e;
    return qs(n(() => ce.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return hu(e, s, o);
        }
    });
}

function Yt(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, ds) || null;
    if (!r) {
        return;
    }
    let i = ui(r, "items");
    lu(i) && (i = cf(i));
    const c = ui(r, "key$");
    const l = ui(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Lt(n, e, o, s, i, u, f);
    }
    return qs(c.resolve(), t => qs(l.resolve(), r => Lt(n, e, o, s, i, t, r)));
}

let Ao = null;

const xo = (t, n, e) => {
    Ao || (Ao = t.insertBefore);
    Ao.call(t, n, e);
};

function Gt(t) {
    let n = null;
    let e = null;
    let o = null;
    const r = new Set;
    const i = () => {
        if (o) {
            if (o.length === 1) {
                xo(n, o[0], e);
            } else {
                const t = n.ownerDocument || n;
                const s = t.createDocumentFragment();
                for (let t = 0; t < o.length; t++) {
                    s.appendChild(o[t]);
                }
                xo(n, s, e);
            }
            o = null;
            n = null;
            e = null;
            r.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof ho) {
            if (n === l.parent && e === l.beforeTarget) {
                o || (o = []);
                o.push(l.target);
                r.add(l.target);
                continue;
            }
            if (!o) {
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (r.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            xo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof co) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof fo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof ao) {
            l.target.nodeValue = l.text;
        } else if (l instanceof po) {
            const t = l.target;
            const e = l.attrName;
            const o = l.attrValue;
            const r = o != null ? s(e, o, l.scopedStyleIdPrefix) : null;
            const c = r == null || r === !1;
            if (Io(t, e)) {
                t[e] = No(r);
            } else if (e === Ss) {
                n === t && i();
                t.innerHTML = r;
                t.setAttribute(es, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = r : E(t, e, r, l.isSvg);
            }
        }
    }
    i();
}

const Io = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const No = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Co = (t => () => queueMicrotask(t))(tn);

const jo = Vs(tn);

let Lo = !1;

function Kt() {
    if (!Lo) {
        Lo = !0;
        Co();
    }
}

function Zt() {
    if (!Lo) {
        Lo = !0;
        jo();
    }
}

function tn() {
    Lo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (nn(e, n)) {
            Zt();
            return;
        }
    }
}

function nn(t, n) {
    const e = $e;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        en(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, on(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Jt(l, r);
            } else if (l.dirty & 64) {
                const n = rn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, on(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ft(l, r, s);
            } else if (l.dirty & 2) {
                e = Wt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Vt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Ut(l, r, i, t);
            } else if (l.dirty & 256) {
                e = Yt(l, r, i, t);
            } else if (l.dirty & 16) {
                Ht(l, i);
            } else if (l.dirty & 32) {
                e = Qt(l, r);
            } else if (l.dirty & 64) {
                const n = rn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && Dt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Ps(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                Kt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    en(r, t, s, e);
}

function en(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Gt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    su(s, t, s.ft);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                sn(t);
            });
            return;
        }
        sn(t);
    }
}

function sn(t) {
    t.ht();
}

function rn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = on(o[0], s, t);
    p(t, n, i);
    return i;
}

function on(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && ln(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return on(s, n, e);
}

function ln(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(rs in n.props) || !t.getHostProp(n, rs)) {
        return !1;
    }
    cn(n) || un(t, n, 0);
    return !0;
}

function un(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Ir.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    Kt();
    return r;
}

function cn(t) {
    return (t.flags & 256) !== 0;
}

function fn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Nr);
            if (!e || e.size === 0) {
                return;
            }
            for (const [o, r] of e.entries()) {
                let e = r.value;
                lu(e) && (e = e.value);
                const i = s(o, e, r.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, o, i);
            }
        }(t, n);
        n.dirty & 32 && Qt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(ps);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof ru) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = su(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ps(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, ds) || null;
            if (!s) {
                return;
            }
            let o = ui(s, "items");
            lu(o) && (o = cf(o));
            const r = await ui(s, "key$").resolve();
            const i = await ui(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const Fo = [];

function an(t) {
    for (let n = 0; n < Fo.length; n++) {
        const e = Fo[n];
        const s = Fo[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function hn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return $e;
    }()) {
        const e = fn(t, n);
        Ps(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            Fo.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = cn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    an(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    Fo.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                Fo.push(r);
                r = r.slotParent || r.parent;
            }
            Fo.length = 0;
            ((t, ...n) => {
                const e = be(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (cn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        cn(n) ? M(n, P(t, n)) : function l(t, n) {
            Fo.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = cn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    M(n, e);
                    an(s);
                    Fo.length = 0;
                    return !0;
                }
                Fo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            Fo.length = 0;
            return !1;
        }(t, n) || un(t, n, 0);
    }
}

function dn(t, n) {
    t.push(n);
}

const Xo = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Do = t => {
    let n = null;
    return e => {
        n || (n = Xo(e, t));
        return n.call(e);
    };
};

const Wo = (t, n, e = null) => {
    const s = new qr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Vo = t => {
    const n = new qr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Uo = (t, n) => {
    const e = new Mr(-4084, null, null, null, null, t, n);
    return e;
};

const zo = () => {
    const t = new Tr(null, -4094, null, null, null, null, null, null);
    return t;
};

const Bo = t => t instanceof Pr;

const Ho = t => (t.flags & 1) === 1;

const Jo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Qo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Yo = t => (t.flags & 4) === 4;

const Go = t => (t.flags & 2) === 2;

const Ko = t => {
    const n = t.flags;
    return (n & 2) === 2 && Zo(t, De, null) !== null;
};

const xh = t => t;

const Zo = (t, n, e) => {
    if (Ho(t) || Go(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const tl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const nl = (t, n, e, s, o = null) => {
    if (Ho(n)) {
        tl(n, e, s);
        dn(t, bo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const el = t => {
    if (t.key) {
        return;
    }
    const n = Il(t.node, Es);
    n && (t.key = n);
};

const sl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ns(c)) {
                pn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Es && c) {
                if (c.startsWith(es)) {
                    const t = i.value;
                    t === "html" ? tl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && tl(e, "value", s.value);
                } else {
                    const t = i.value;
                    tl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Zo(e, ys, null) === null && Zo(e, ms, null) === null || (n.flags |= 64);
    }
};

const rl = t => {
    if (t.vt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ae(n)) {
            return n;
        }
    }
    return t;
};

function pn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = rl(Nn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function $n(t, n, e) {
    let s = Tl(n);
    for (;s; ) {
        if (Yo(s)) {
            ol(t, s);
            e(s, n);
        } else {
            Ho(s) ? e(s, n) : $n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function yn(t) {
    let n = t;
    if (Yo(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Tl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const il = (t, n, e) => {
    let s = t;
    for (;e && s && Go(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Go(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Go(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Yo(t) && e && Ho(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Ql(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const ol = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = _l(n, !0);
        const o = e.node;
        const r = Vl(s);
        let i = il(n, !1, !0);
        const c = il(n, !0, !0);
        const l = o || (c && Ho(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Yo(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                dn(t, wo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = il(i, !1, !0);
        }
        i = n;
        for (;i && Yo(i); ) {
            const n = il(i, !0, !0);
            const e = !n || !Yo(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    dn(t, mo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    dn(t, wo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const ll = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = Vo(i);
            el(e);
            t.vNode = e;
            return e;
        }
    }
    if (Bo(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || Vo(i);
            el(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = fl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = al(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = ul(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const ul = (t, n) => {
    let e = Tl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const cl = [];

const fl = (t, n) => {
    let e = Tl(t);
    for (;e && (!(e instanceof qr) || e.node !== n); ) {
        if (Go(e)) {
            const t = e.nextSibling;
            const n = Tl(e);
            if (n) {
                t && cl.push(t);
                e = n;
            } else {
                e = t || (cl.length ? cl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || cl.pop();
        }
    }
    for (;cl.length; ) {
        cl.pop();
    }
    return e;
};

const al = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const hl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Wo(o, "errored-host");
    if (Jo(e)) {
        vl(t, r, e, null);
    } else {
        const n = [];
        $n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            vl(t, r, n[e], null);
        }
    }
    return r;
};

const dl = Gt;

const pl = (t, n, e, s) => {
    const o = Ho(n);
    o && ql(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    wl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : _l(n, !1);
    l && !c && dn(t, wo(i, l, yl(t, n, s)?.node ?? null));
    ml(n, e, s);
    c && (e.flags |= 32);
};

const $l = (t, n, e, s) => {
    const r = Ho(n);
    r && ql(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    wl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Fe] : null;
    const f = u ? null : r ? n : gl(n, !1);
    const a = u || f?.node;
    const h = yl(t, n, s);
    const d = h?.node ?? null;
    const p = Ko(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = gl(n, !1);
        const c = yl(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        $n(t, e, n => {
            if (Yo(n)) {
                dn(t, wo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Ho(c)) {
                                e = c.node;
                                const t = kl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && gl(l, !0);
                                if (h) {
                                    const t = o(h, kl(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Tl(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Al(e)) {
                                    const t = re(e);
                                    if (t) {
                                        const n = Tl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                dn(t, wo(n.node, a, c));
            }
        });
    } else {
        a && !l && $n(t, e, n => {
            dn(t, wo(n.node, a, d));
        });
    }
    ml(n, e, s);
    l && (e.flags |= 32);
};

const yl = (t, n, e) => {
    let s = null;
    e == null ? Go(n) && (s = il(n, !0, !1)) : s = Go(e) ? il(e, !0, !0) : e;
    s && Yo(s) && ol(t, s);
    return s;
};

const ml = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const wl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && El(t, n, s, !1);
};

const bl = (t, n) => {
    let e = n;
    for (;e && Go(e); ) {
        e = e.lastChild;
    }
    e && Yo(e) && (e.flags & 8) === 0 && ol(t, e);
};

const vl = (t, n, e, s) => {
    Jo(e) ? pl(t, n, e, s) : $l(t, n, e, s);
};

const _l = (t, n) => {
    for (;t && !Ho(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Fe];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const gl = (t, n) => {
    for (;t && !Ho(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const El = (t, n, e, s) => {
    Yo(e) && ol(t, e);
    if (s) {
        const s = Zo(n, Ss, null) !== null;
        if (s) {
            return;
        }
        Jo(e) ? dn(t, $o(e.node)) : $n(t, e, n => {
            dn(t, $o(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Sl = (t, n, e, s = !0) => {
    const o = _l(n, !0);
    if (o && s) {
        if (Jo(n)) {
            dn(t, yo(n.node));
        } else {
            const e = gl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? dn(t, yo(o)) : $n(t, n, n => {
                dn(t, $o(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const kl = t => {
    const n = xh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Wl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Dl(t);
            switch (n) {
              case us:
                return 512;

              case cs:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Rl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Pl = (t, n, e) => {
    ol(t, n);
    n.text = e;
    dn(t, mo(n.node, e));
};

const Tl = t => {
    if (Yo(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Ho(t) && function e(t) {
        const n = t.getAttribute(Th);
        if (n === null) {
            return !1;
        }
        const e = Xl(t);
        return tu(e) && e.localName === "template" && e.getAttribute(Ph) === n && jl(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = ql(t));
    return n;
};

const ql = n => {
    const e = xh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Al(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Xl(e);
            const o = Vl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                el(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === Oe && o.charCodeAt(1) === Oe) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Ul(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = tu(t);
                            return !n || n && vn(t);
                        };
                        let p = null;
                        zl(e, ($, y, m, w, b) => {
                            if (Yl($())) {
                                for (;d(o); ) {
                                    o = jl(o);
                                    if (!o) {
                                        throw qe(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Yl($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = Vo(o);
                                    el(n);
                                    u(n);
                                    o = jl(o);
                                    for (;tu(o) && vn(o); ) {
                                        o = jl(o);
                                        if (!o && t > 0) {
                                            throw qe(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                tl(n, He, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                tl(n, Le, y());
                            } else if ($() === 61) {
                                h || (h = se(s));
                                const t = y();
                                h.xn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                tl(n, ds, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Oe;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                tl(n, ps, y());
                            } else if ($() === 94) {
                                tl(n, $s, y());
                            } else if ($() === 96) {
                                h || (h = se(s));
                                wn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = se(s));
                                n.slotParent = ll(h.rootVNode, y());
                            } else if ($() === 93) {
                                tl(n, Je, y());
                            } else if ($() === 123) {
                                m();
                                u(zo());
                                Kl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Oe) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === Oe;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                tl(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = Kl.pop();
                                l = Kl.pop();
                                c = Kl.pop();
                                i = Kl.pop();
                                n = Kl.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                tl(n, De, e);
                            } else {
                                for (;tu(o) && vn(o); ) {
                                    o = jl(o);
                                }
                                const t = o && Nl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Gl($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Mr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = se(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Ul(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Ml = null;

const Al = t => {
    Ml || (Ml = t.hasAttribute);
    return Ml.call(t, es);
};

let xl = null;

const Il = (t, n) => {
    xl || (xl = t.getAttribute);
    return xl.call(t, n);
};

const Nl = Do("nodeType");

const Cl = t => {
    const n = Nl(t);
    return n === 3 || n === 1;
};

let Ol = null;

const jl = t => {
    Ol || (Ol = Xo(t, "nextSibling"));
    Fl || (Fl = Xo(t, "firstChild"));
    for (;t; ) {
        t = Ol.call(t);
        if (t !== null) {
            const n = Nl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(ts)) {
                    return mn(t, Ke, Ol, Fl);
                }
                if (t.nodeValue?.startsWith(Ze)) {
                    return mn(t, [ Ke, ns ], Ol, Fl);
                }
                if (n?.startsWith(es)) {
                    for (;t && (t = Ol.call(t)) && (Nl(t) !== 8 || !t.nodeValue?.startsWith(ss)); ) {}
                }
            }
        }
    }
    return t;
};

function mn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = Ll(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const Ll = Do("parentNode");

let Fl = null;

const Xl = t => {
    Fl || (Fl = Xo(t, "firstChild"));
    t = t && Fl.call(t);
    if (t && Nl(t) === 8) {
        Ol || (Ol = Xo(t, "nextSibling"));
        if (t.nodeValue?.startsWith(ts)) {
            return mn(t, Ke, Ol, Fl);
        }
    }
    for (;t && !Cl(t); ) {
        t = jl(t);
    }
    return t;
};

const Dl = Do("namespaceURI");

const Wl = Do("nodeName");

const Vl = Do("ownerDocument");

const Ul = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;tu(i) && vn(i); ) {
            i = jl(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = Nl(i);
        let e = null;
        if (n === 3) {
            e = Uo(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = Vo(i);
            el(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = jl(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        zl(e, (e, s) => {
            if (e() === 61) {
                n || (n = se(t.node));
                const e = s();
                n.xn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = se(t.node));
                wn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function wn(t, n, e) {
    if (t[_r]) {
        const s = t[_r];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, _r, {
            get() {
                const s = e._(n);
                t[_r] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, _r, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const zl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Bl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        sl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Es) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Hl = (t, n) => {
    let e = Jl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Jl(e);
    }
    return !1;
};

const Jl = t => t.parent || t.slotParent;

const Ql = t => {
    if (t === null || Go(t)) {
        return null;
    }
    return t.node;
};

function bn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Ho(e)) {
                        const t = ie(e.node);
                        if (!t) {
                            return null;
                        }
                        return re(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Yo(i)) {
            c.push(Pn(Rl(i)));
        } else if (Go(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Bl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== xe && e !== "__scopedStyleIdPrefix__") {
                        const t = Zo(i, e, null);
                        s.push(" " + e + "=" + Pn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Ie[Zo(i, xe, null) || "V"] || Ie.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Tl(i);
            u && c.push("  " + bn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Ho(i)) {
            const s = kl(i);
            const l = [];
            cn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Bl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Zo(i, n, null);
                l.push(" " + n + "=" + Pn(e));
            }
            const f = Ql(i);
            if (f) {
                const t = Vl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Pn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Pn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Qo(i) || e) {
                const e = Tl(i);
                e && c.push("  " + bn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Yl = t => 48 <= t && t <= 57;

const Gl = t => 97 <= t && t <= 122;

function vn(t) {
    return !t.hasAttribute(Es) || t.nodeName === "STYLE" && (t.hasAttribute(He) || t.hasAttribute(Ue));
}

const Kl = [];

const Zl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw qe(26, [ n ]);
};

const tu = t => t && typeof t == "object" && Nl(t) === 1;

const nu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Go(t) || Zo(t, Le, null) === null); ) {
            const e = t.slotParent;
            const s = Go(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function _n(t, n) {
    Bo(n) && Ho(n) && ql(n);
    const e = n[_r];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        gn(t, n);
    }
    e.clear();
}

function gn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Jr) {
            Sn(s, n);
        } else if (s instanceof zr) {
            En(t, s, n);
        } else if (ai(s)) {
            const t = s[Zr];
            kn(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = mu(e);
            kn(o, n);
        }
    }
    e.clear();
}

function En(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof Pi && !s?.size) {
        n.m = void 0;
        _n(t, n);
    }
}

function Sn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function kn(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const eu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = vo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new ru(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Xt: u} = o;
    const f = qs(u, () => su(c, l, o.m));
    Ps(f) && (o.Xt = f);
};

const su = (t, n, e) => {
    const s = t.In;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = qs(((t, n) => {
        const e = t.Nn;
        if (e) {
            return e;
        }
        const s = t.Tn;
        if (!s) {
            return;
        }
        t.Tn = null;
        try {
            const e = s();
            if (Ps(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Nn === s && (t.Nn = void 0);
                });
                t.Nn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = he(n.jt, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => _n(n, t));
        const c = Ur(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Tn = () => {
                            t.Tn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ps(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Ts(() => i(u), l, s => {
            if (Ps(s)) {
                return s.then(() => {
                    t.In === r && (t.In = null);
                    return su(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ps(i)) {
        r = i.finally(() => {
            t.In === r && (t.In = null);
        });
        t.In = r;
        return r;
    }
    return i;
};

class ru extends gr {
    h;
    Qt;
    ft;
    bt;
    Ot;
    Tn;
    Nn;
    In=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Qt = n;
        this.ft = e;
        this.bt = s;
        this.Ot = o;
        this.Tn = r;
    }
}

const iu = t => t instanceof ru;

function Rn(t, n) {
    const e = se(n);
    typeof this === "string" && Pf(Tf(e, this));
    const s = Rf[0];
    s.h |= 4;
    hn(e, s.ft, 1);
}

const ou = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const lu = t => t instanceof zr;

const uu = (t, n) => {
    t.add(n);
};

const cu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const fu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        iu(e) ? o = e.bt : e instanceof Br ? o = e.en : s === ":" && (o = n.getHostProp(e, Le));
        o && n.serializationCtx.xt.add(o);
    }
};

const au = (t, n) => {
    if (t && (!n || t === n || Ah(t))) {
        return t;
    }
    return n;
};

const hu = (t, n, e) => {
    const s = ye;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (iu(o)) {
                o.h |= 4;
                hn(t, o.ft, 1);
            } else if (o instanceof zr) {
                o.invalidate();
            } else if (r === ":") {
                hn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Xt(o, n);
                    hn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ti) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Nr];
                            if (!o) {
                                o = new Map;
                                s[Nr] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Nr);
                        if (!n) {
                            n = new Map;
                            t.setProp(Nr, n);
                        }
                        n.set(r, c);
                    }
                    hn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const du = t => ke(t) && typeof t[Fc] === "function";

const pu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const $u = [];

function Pn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (iu(t)) {
            return `Task(${Pn(t.bt)})`;
        }
        if (Ae(t)) {
            return `Qrl(${t.vt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if ($u.includes(t)) {
                return "*";
            }
            $u.length;
            try {
                $u.push(t);
                if (Array.isArray(t)) {
                    return Bo(t) ? "(" + (Zo(t, xe, null) || "vnode") + ")" : t.map(Pn);
                }
                if (lu(t)) {
                    return t instanceof Pi ? "WrappedSignal" : t instanceof Br ? "ComputedSignal" : "Signal";
                }
                if (gu(t)) {
                    return "Store";
                }
                if (Ai(t)) {
                    return yu(t);
                }
                if (Bo(t)) {
                    return "(" + (Zo(t, xe, null) || "vnode") + ")";
                }
            } finally {
                $u.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const yu = t => {
    if (Ai(t)) {
        if (typeof t.type === "function") {
            const n = t.type[zf];
            if (n) {
                const [t] = n;
                return "Component(" + t.vt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Pn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += yu(e);
                    }
                } else {
                    n += yu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const mu = t => t[Wr];

const wu = t => t?.[Dr] || null;

const bu = (t, n) => {
    const e = mu(t);
    e && e.force(n);
};

const vu = (t, n) => {
    const e = mu(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const _u = t => wu(t) || t;

const gu = t => Dr in t;

function Tn(t, n, e) {
    return new Proxy(n, new Su(e, t || null));
}

const Eu = (t, n, e) => {
    if (Se(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = Tn(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class Su {
    h;
    $;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = wu(this);
        hu(this.$, this, An(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Dr) {
                return t;
            }
            if (n === Wr) {
                return this;
            }
            return t[n];
        }
        const e = rf();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ft;
            o && qn(t, Array.isArray(t) ? Vr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ke(s) && !Object.isFrozen(s) && !gu(s) && !Object.isFrozen(t)) {
            return Eu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? _u(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Mn(n, s, t, this);
        } else {
            Mn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || hu(this.$, this, An(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === Dr) {
            return !0;
        }
        if (typeof n === "string") {
            const e = rf();
            if (e) {
                const s = e.Ft;
                s && qn(t, Array.isArray(t) ? Vr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = rf();
        const e = n?.Ft;
        e && qn(t, Vr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function qn(t, n, e, s, o) {
    const r = e.ct ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = $e;
    const l = __EXPERIMENTAL__.suspense && e instanceof Su && c;
    uu(i, s);
    cu(s, t);
    if (c) {
        const i = au(o, e.$);
        l && i?.nn?.(t, s, n, r);
        fu(s, i);
    }
}

function Mn(t, n, e, s) {
    e[t] = n;
    const o = An(e, t, s.ct);
    o && hu(s.$, s, o);
}

function An(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Vr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const ku = Symbol();

const Ru = [ void 0, null, !0, !1, "", ei, si, Fr, Vr, ni, Ki, Yi, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const Pu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const Tu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch" ];

function xn(t, n, e) {
    let s = n.vt;
    let o = n._t;
    const r = Js();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ae(t) && t.vt == Me)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.Et(n.it));
        if (!o) {
            throw qe(14, [ n.vt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.St(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function In(t, n, e, s) {
    return xf(t, n, null, null, e, s);
}

function Nn(t, n) {
    const [e, s, o] = t.split("#");
    return In(e, s, o || null, n);
}

class qu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Mu {
    On;
    jn=0;
    Rt=[];
    Ln=0;
    Fn=new Set;
    Xn=new Map;
    Dn;
    Wn=new Map;
    Vn=0;
    Nt;
    Un=typeof Temporal !== "undefined";
    constructor(t) {
        this.On = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        const t = this.Vn;
        this.Vn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Vn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Vn;
        this.Vn = s;
        this.Nt.write(yr);
        this.On.zn = 0;
        try {
            this.Nt.write(t + "");
            this.Nt.write(wr);
            this.Nt.write(yr);
            await this.outputSelectedRoots(n);
            this.Nt.write(mr);
            const s = this.getForwardRefsPayload();
            this.On.zn = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Nt.write(wr);
                s ? this.outputForwardRefsArray(s) : this.Nt.write("0");
            }
            if (e !== void 0) {
                this.Nt.write(wr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Nt.write($r);
                    this.writeRootRefPath(e);
                    this.Nt.write($r);
                }
            }
        } finally {
            this.Vn = o;
        }
        this.Nt.write(mr);
    }
    Bn(t) {
        this.Nt = t;
    }
    outputArray(t, n, e) {
        this.Nt.write(yr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(wr) : s = !0;
            e(t[n], n);
        }
        this.Nt.write(mr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : $r + t + $r;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Nt.write(n.slice(s, e));
            this.Nt.write("<\\/");
            s = e + 2;
        }
        this.Nt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Nt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Nt.writeRootRefPath(t);
    }
    outputStringChunks(t) {
        this.Nt.write($r);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Nt.write(e) : typeof e === "number" ? this.writeRootRef(e) : this.writeRootRefPath(e.path);
        }
        this.Nt.write($r);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Nt.write(t + wr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Nt.write($r);
                this.writeRootRefPath(n);
                this.Nt.write($r);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Nt.write(t + wr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Nt.write(t + wr + n);
        } else if (typeof n === "string") {
            this.Nt.write(t + wr);
            this.outputString(n);
        } else {
            this.Nt.write(t + wr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.On.getSeenRef(t);
        const o = !e && this.Xn.get(t);
        if (s) {
            s.Dn && this.isSeenInStreamedRoot(s) && (s = this.On.Hn(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.On.Jn(t, this.Dn, n);
            }
            s = this.On.St(t, !0);
        }
        if (s.Dn) {
            if (this.Dn) {
                this.On.Qn(s, t);
            } else {
                this.On.Qn(s, t, n);
                t = this.On.Yn[n];
            }
        }
        if (typeof o === "number") {
            this.Rt[o] = s.Qt;
            this.Xn.delete(t);
        }
        const r = t instanceof ju ? t.Gn : s.Qt;
        if (!this.Dn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Dn; ) {
            t = t.Dn;
        }
        return t.Qt < this.Vn;
    }
    writeValue(t, n) {
        if (Oc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Fr) {
                    this.output(3, 7);
                } else if (t === Vr) {
                    this.output(3, 8);
                } else if (t === ni) {
                    this.output(3, 9);
                } else {
                    if (t !== ku) {
                        throw qe(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === Ki) {
                    this.output(3, 10);
                } else if (t === Yi) {
                    this.output(3, 11);
                } else if (Ae(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = xn(this.On, t, !0);
                        let o;
                        if (n !== "") {
                            o = [ this.On.St(n), "#", this.On.St(e) ];
                            if (s) {
                                const t = s.split(" ");
                                o.push("#");
                                for (let n = 0; n < t.length; n++) {
                                    n > 0 && o.push(" ");
                                    o.push(+t[n]);
                                }
                            }
                            const r = o.join("");
                            const i = this.Wn.get(r);
                            if (i) {
                                const t = this.On.St(i);
                                this.output(1, t);
                                return;
                            }
                            this.Wn.set(r, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Bf(t)) {
                        throw qe(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[zf];
                        this.On.Kn.add(n.vt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ei) {
                    this.output(3, 5);
                } else if (t === si) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof ju) {
                    this.output(1, t.Gn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Dn;
                        this.Dn = e;
                        this.writeObjectValue(t);
                        this.Dn = n;
                    }
                }
                break;

              default:
                throw qe(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ai(t)) {
            const n = t[Kr];
            this.output(38, [ Cu(n), n.varProps, n.constProps, t[Zr].ct ]);
        } else if (t instanceof Ti) {
            this.output(39, [ t.data.O, t.data.et ]);
        } else if (t instanceof Xr) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof qu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (gu(t)) {
            const n = mu(t);
            const e = wu(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.On.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (du(t)) {
            const n = t[Fc](t);
            if (Ps(n)) {
                const t = this.resolvePromise(n, (t, n) => new Au(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Dn.Qt;
                this.Dn = this.Dn.Dn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Oc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.On.Zn(t)) {
            this.On.te(t.ne, 16);
            this.output(11, t.ne.id);
        } else if (t instanceof zr) {
            if (t instanceof di) {
                const n = function e(t, n) {
                    if (n === Fr) {
                        return n;
                    }
                    return qs(t.en.resolved || t.en.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Fc in n && (e = n[Fc](n));
                        e === void 0 && (e = Fr);
                        return e;
                    });
                }(t, t.Zt);
                if (Ps(n)) {
                    const e = this.resolvePromise(n, (n, e) => new Au(34, n, e, t.ct, t.en));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.en, t.ct, n ]);
                }
                return;
            }
            if (t instanceof Pi) {
                this.output(31, [ ...Cn(this.On, t), t.h, t.m, ...t.ct || [] ]);
            } else if (t instanceof Br) {
                let n = t.Zt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Oc(t.Zt);
                const i = t instanceof Jr;
                const c = i && t.Pt !== 0 ? t.Pt : void 0;
                const l = i && t.yn !== 1 ? t.yn : void 0;
                const u = i && t.wn !== 0 ? t.wn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Fr : e ? n = t.Zt : s && (n = Fr);
                const a = [ t.en, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.pn);
                    a.push(f || void 0);
                }
                n === Fr && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? ku : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Zt;
                const e = [ n === void 0 ? ku : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Un && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Un && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Un && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.On.ee(t)) {
            const n = this.On.St(t);
            this.On.se(t, as, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                xu(e, t => {
                    this.On.St(t);
                });
                this.On.te(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.On.te(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ai(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof ru) {
            const n = [ t.bt, t.h, t.Qt, t.ft, t.Ot ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ps(t)) {
            const n = this.resolvePromise(t, (t, n) => new Au(24, t, n));
            this.output(2, n);
        } else if (t instanceof Au) {
            if (t.re === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ct, t.ie ]);
                } else {
                    if (!t.oe) {
                        console.error(t.ie);
                        throw qe(33);
                    }
                    {
                        const n = this.Dn.Qt;
                        this.Dn = this.Dn.Dn;
                        this.writeValue(t.ie, n);
                    }
                }
            } else {
                this.output(24, [ t.oe, t.ie ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof Nu) {
            const n = t.le;
            if (this.getSeenRefOrOutput(n, this.Dn.Qt, !0)) {
                let t = this.Xn.get(n);
                if (t === void 0) {
                    t = this.Ln++;
                    this.Xn.set(n, t);
                    this.Rt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else {
            if (!Bo(t)) {
                throw qe(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Ln++;
        t.then(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!0, s));
        }).catch(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!1, s));
        });
        this.Fn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.On.ue + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {Yn: n} = this.On;
        for (;this.jn < n.length || this.Fn.size; ) {
            let e = t > 0;
            for (;this.jn < n.length; this.jn++) {
                e ? this.Nt.write(wr) : e = !0;
                this.writeValue(n[this.jn], this.jn);
                t++;
            }
            if (this.Fn.size) {
                try {
                    await Promise.race(this.Fn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Fn.size; ) {
            if (e < t.length) {
                n ? this.Nt.write(wr) : n = !0;
                const s = t[e++];
                this.writeValue(this.On.Yn[s], s);
                continue;
            }
            try {
                await Promise.race(this.Fn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Rt.length - 1;
        for (;t >= 0 && this.Rt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Rt.length - 1 ? this.Rt : this.Rt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Nt.write($r);
                this.writeRootRefPath(t);
                this.Nt.write($r);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Nt.write(yr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.On.ce = this.On.Yn.length;
        this.On.fe = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Nt.write(wr);
            this.Nt.write(14 + wr);
            this.outputForwardRefsArray(n);
        }
        this.Nt.write(mr);
        this.On.ae = this.On.Yn.length + (this.On.fe ? 1 : 0);
        this.On.zn = e;
    }
}

class Au {
    re;
    oe;
    ie;
    ct;
    bt;
    constructor(t, n, e, s, o) {
        this.re = t;
        this.oe = n;
        this.ie = e;
        this.ct = s;
        this.bt = o;
    }
}

const xu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Iu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === as || t === ds && dr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Iu = t => typeof t === "object" && t !== null && !dr(t);

function Cn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class Nu {
    le;
    constructor(t) {
        this.le = t;
    }
}

const Cu = t => new Nu(t);

let Ou = () => !1;

class ju {
    Gn;
    constructor(t) {
        this.Gn = t;
    }
}

class Lu {
    NodeConstructor;
    DomRefConstructor;
    Et;
    se;
    dt;
    Nt;
    he=new Map;
    de=new Map;
    pe=0;
    $e=[];
    Yn=[];
    ye=[];
    me;
    ue=0;
    ae=0;
    zn=0;
    ce=0;
    fe=!1;
    Tt=new Set;
    xt=new Set;
    At=new Set;
    Kn=new Set;
    we;
    te=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Et = e;
        this.se = s;
        this.dt = o;
        this.Nt = r;
        this.we = new Mu(this);
    }
    async It() {
        await this.we.serialize();
    }
    async be(t, n, e, s) {
        await this.we.serializePatch(t, n, e, s);
    }
    Bn(t) {
        this.Nt = t;
        this.we.Bn(t);
    }
    getSeenRef(t) {
        return this.he.get(t);
    }
    Jn(t, n, e) {
        const s = {
            Qt: e,
            Dn: n
        };
        this.he.set(t, s);
        return s;
    }
    ve(t) {
        const n = [];
        for (;t.Dn; ) {
            n.unshift(t.Qt);
            t = t.Dn;
        }
        n.unshift(t.Qt);
        return n;
    }
    Qn(t, n, e) {
        const s = this.ve(t);
        const o = e === void 0;
        e === void 0 && (e = this.Yn.length);
        this.Yn[e] = new ju(s);
        o && (this.ye[e] = n);
        t.Dn = null;
        t.Qt = e;
        o && this.me?.(e, this.Yn[e], n);
    }
    St(t, n = !1) {
        let e = this.he.get(t);
        let s;
        if (e) {
            e.Dn && this.Qn(e, t);
            s = e.Qt;
        } else {
            s = this.Yn.length;
            e = {
                Qt: s
            };
            this.he.set(t, e);
            this.Yn.push(t);
            this.ye.push(t);
            this.me?.(s, t, t);
        }
        return n ? e : s;
    }
    Hn(t) {
        const n = this.Yn.length;
        const e = {
            Qt: n
        };
        this.he.set(t, e);
        this.Yn.push(t);
        this.ye.push(t);
        this.me?.(n, t, t);
        return e;
    }
    _e(t, n) {
        const e = this.Yn.length;
        const s = {
            Qt: e
        };
        this.he.set(n, s);
        this.Yn.push(t);
        this.ye.push(n);
        return e;
    }
    ee(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Zn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ge(t) {
        const n = this.he.get(t);
        return n && (n.Dn ? void 0 : n.Qt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.de.get(t);
        if (o === void 0) {
            o = this.pe + this.$e.length;
            this.de.set(t, o);
            if (s) {
                this.$e.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.$e.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ee(t, n) {
        this.pe = t;
        if (n) {
            this.de.clear();
            for (let t = 0; t < n.length; t++) {
                this.de.set(n[t], t);
            }
        }
    }
}

const Fu = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(pr(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Ou = n ? t => t instanceof n : () => !1;
    return new Lu(t, n, e, s, o, r);
};

const Xu = (t, n) => t[n];

const Du = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        gu(t) && (t = wu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Du(cf(Xu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Du(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (iu(t)) {
            return !0;
        }
        if (ai(t)) {
            return !0;
        }
        if (Ps(t)) {
            return !0;
        }
        if (Ai(t)) {
            return !0;
        }
        if (du(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ti) {
            return !0;
        }
        if (Ou?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ae(t) || Bf(t) || t === Ki || t === Yi) {
            return !0;
        }
    } else if (t === ni || t === Fr || t === Vr) {
        return !0;
    }
    return !1;
};

const Wu = (t, n) => {
    let e = Bo(t) ? bn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Vu = !1;

const Uu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Vu = !0);
            const n = `{${ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Wu(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Bu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Uu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${zu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Vu ? "" : `(${JSON.stringify(t).length} chars)`;
        Vu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const zu = t => Tu[t] || `Unknown(${t})`;

const Bu = t => Pu[t] || `Unknown(${t})`;

function On(t, n, e, s = 0) {
    const o = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const r = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let e = s; e < t.length; e += 2) {
        o(t[e], t[e + 1]) ? i(e) : r(t[e]) && (n.Rt = t[e + 1]);
    }
}

const Hu = new WeakMap;

const Ju = new Map;

const Qu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Ct(e);
        return s === -1 || s === void 0 ? ni : t._(s);

      case 14:
        return e;

      case 3:
        return Ru[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = In(i, c, r || null, t);
            } else {
                n = In("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new ru(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Uf(null);

      case 30:
        return new zr(t, 0);

      case 31:
        return new Pi(t, null, null, null);

      case 32:
        return new Br(t, null);

      case 33:
        return new Jr(t, null, void 0, {});

      case 34:
        return new di(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Qu(t, s, o);
            const i = Eu(r, 0, t);
            Pc(s) && Ju.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new qi(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Hu.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return jn(t, e);

      case 11:
        const h = jn(t, e);
        if (Bo(h)) {
            ql(h);
            return Ql(h);
        }
        throw qe(17, [ typeof h ]);

      case 39:
        return new Ti({});

      case 40:
        return new Xr(null, null, null, null);

      case 41:
        return new qu;

      default:
        throw qe(18, [ n ]);
    }
};

function jn(t, n) {
    return n ? t.rootVNode ? ll(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Yu = (t, n, e) => {
    let s = null;
    let o = null;
    if (Te(t)) {
        o = t;
    } else {
        if (!Pe(t)) {
            throw qe(7, [ t ]);
        }
        s = t;
    }
    return xf(s, n, null, o, e);
};

const Gu = (t, n, e) => xf(null, n, t, null, e);

const Ku = (t, n) => xf(null, t, null, null, n);

const Zu = (t, n, e) => {
    const s = Ku(t, e);
    return s;
};

const tc = (t, n, e, s) => xf(t, e, null, n, s);

const nc = (t, n, e, s, o) => {
    const r = tc(t, n, e, o);
    r.Se(s);
    return r;
};

const ec = (t, n, e, s) => {
    const o = Yu(t, n, s);
    return o;
};

const sc = (t, n, e, s) => {
    const o = Gu(t, n, s);
    return o;
};

const rc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const ic = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Ln(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const oc = (t, n, e) => new Pi(null, t, n, e || null);

class lc {
    ke;
    dt;
    Re=null;
    Cn=!1;
    jt;
    _;
    Dt;
    Pe=0;
    Te=null;
    qe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Dt = t;
        this.jt = n;
        this.ke = br;
        this.dt = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return hf(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return Fu(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const uc = Symbol();

const Nh = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[uc] = t;
    return n;
};

class cc {}

function Fn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Xn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === cc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ps(n) && await n;
                    }
                    continue;
                }
                Dn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ps(n) && await n;
            }
        }
    })();
}

function Dn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (lu(e)) {
            (function s(t, n) {
                const e = n instanceof Pi ? n.rt() : n;
                if (e instanceof Jr) {
                    const n = e.Pt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(si);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Pi ? e.rt() : e;
            n(t.closeFragment);
            n(() => hf(r, o, ".", t));
            n(cc);
        } else if (Ps(e)) {
            t.openFragment(si);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Xn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = li(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (Te(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && uc in t)(r)) {
                    n(() => (t => t[uc])(r)(t, o, s, n));
                    return;
                }
                if (r === Yi) {
                    const e = o.key != null ? {
                        [hs]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === Ki) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = li(o, rs);
                        c && (i[rs] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[De] = f;
                        n(Fn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Fn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = si;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === no) {
                    t.commentNode(li(o, "data") || "");
                } else if (r === so) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Te(e) ? e({
                        async write(n) {
                            await Xn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    Ps(r) && n(Promise);
                } else if (r === to) {
                    t.htmlNode(li(o, "data"));
                } else if (r === eo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (Bf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[zf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Le, o);
                        s.setProp(ds, r);
                        n.key !== null && s.setProp(hs, n.key);
                        return Mo(t, s, s, o, r);
                    })(t, o, r);
                    n(Fn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ps(l)) {
                        n(async () => {
                            const t = await l;
                            const e = Is(i.getProp(He));
                            n(t);
                            n(Fn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = Is(i.getProp(He));
                        n(Fn(s, t, c));
                    }
                } else {
                    const e = {
                        [hs]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Mo(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    Ps(i) && n(Promise);
                }
            }
        }
    }
}

const fc = () => Rf;

const ac = async t => {
    const [n, e] = Rf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Tn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const hc = (t, n) => {
    const {val: e, set: s, iCtx: o} = vo();
    if (e) {
        return e;
    }
    const r = xf(null, "_rsc", ac, null, [ t, {} ], o.$);
    const i = $i(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const dc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ps(t)) {
        return t.then(n, s);
    }
    const o = pc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Ps(i) ? i.then(n, s) : n(i);
};

const pc = t => t && t.__brand === "resource";

function Wn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.vt.startsWith("_") || !n.Mt?.length && !s || (n = xf(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = xn(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            const c = o.split(" ");
            for (let t = 0; t < c.length; t++) {
                t > 0 && i.push(" ");
                i.push(+c[t]);
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ae(o)) {
                i(c(o));
                Vn(t, n, o);
            } else if (o != null) {
                const e = Wn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ae(r)) {
        o = c(r);
        Vn(t, n, r);
    }
    return o;
}

function Vn(t, n, e) {
    const s = js(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.At.add(r);
        t.xt.add(e);
    }
}

const $c = (t, n, e) => {
    wc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const yc = (t, n, e) => {
    wc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const mc = (t, n, e) => {
    wc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const wc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = bc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Os(i), e, s);
            }
        } else {
            r(t + Os(n), e, s);
        }
    }
};

const bc = () => {
    const t = lf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, bs);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, bs, s);
    }
    let o = t.$.getHostProp(e, vs);
    o === null && (o = 0);
    t.$.setHostProp(e, vs, o + 1);
    let r = t.$.getHostProp(e, _s);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, _s, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const vc = function(t, n) {
    const e = se(n);
    typeof this === "string" && Pf(Tf(e, this));
    const s = Rf?.[1];
    const o = s ?? n.getAttribute("data-qwik-inspector");
    if (!o || !t.detail.files.some(t => o.startsWith(t))) {
        return;
    }
    const r = Rf?.[0];
    if (!r || r.flags & 32) {
        return;
    }
    hn(e, r, 4);
    const i = n.ownerDocument;
    i.__hmrDone = i.__hmrT;
};

let _c;

function Un(t) {
    const n = rf();
    if (!n) {
        return;
    }
    _c ||= Gu(vc, "_hmr");
    const e = n.m;
    const s = _c.w([ e, t ]);
    yc("qHmr", s);
}

function zn(t, n, e, s, o) {
    const r = zo();
    tl(r, De, o);
    r.parent = n;
    tl(n, o, r);
    tl(r, Le, e);
    tl(r, ds, s);
    r.dirty = 4;
    un(t, r, 1);
    return r;
}

function Bn(t, n) {
    tl(t, Fe, n);
    t.flags |= 2048;
}

function Hn(t, n, e) {
    tl(n, ds, e);
    hn(t, n, 4);
}

function Jn(t, n, e, s) {
    tl(n, s, null);
    const o = [];
    Et(t, o, e);
    dl(o);
    if (e.flags & 2048) {
        const t = Zo(e, Fe, null);
        t && t.replaceChildren();
        tl(e, Fe, null);
        e.flags &= -2049;
    }
}

let gc = Promise.resolve();

const Ec = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Sc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Ec.has(t));
};

const kc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = Rc(t, s));
    switch (e) {
      case 4:
        Rc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Sc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Qt = r[2];
        o.ft = r[3];
        o.Ot = r[4];
        break;

      case 29:
        n[zf][0] = s[0];
        break;

      case 35:
        {
            const e = _u(n);
            const o = Ju.get(e);
            if (o) {
                Ju.delete(e);
                kc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = mu(n);
            c.h = r;
            c.ct = i;
            Gn(c.ct, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            t.ct = new Set(e.slice(1));
            Yn(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Zt = Fr;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Bo(t.m)) {
                    const n = t.m;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Pe(e)) {
                                const o = Zo(n, e, null);
                                if (o !== null) {
                                    t.Zt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Tl(n);
                        e && n.firstChild === n.lastChild && Yo(e) && (t.Zt = Rl(e));
                    }
                }
            })(e);
            Yn(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.en = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.pn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.dn = !0);
            const o = e.length > 6;
            o && (t.Zt = e[6]);
            t.Zt === Fr && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.yn = e[8] ?? 1;
                t.mn = [];
            }
            t.wn = e[9] ?? 0;
            Yn(t.ct, t);
            Yn(t.$t, t);
            Yn(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.en = r[0];
            const i = o.en.resolve(t).catch(() => {});
            gc = gc.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Zt = r[2]);
            e !== 34 && o.Zt !== Fr && (o.h &= -2);
            Yn(o.ct, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Hu.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === ni) {
            a = new qi(Yi, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Kr] = a;
        const h = u[Zr];
        h.ct = f[3];
        Gn(h.ct, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = $e;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[_r] ||= new Map;
                e[_r].set(t.property, t);
            })(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      default:
        throw qe(16, [ e ]);
    }
};

const Rc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Qn(t, n[s], n[s + 1]);
    }
    return e;
};

function Qn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Qu(t, n, e);
    Pc(n) && kc(t, s, n, e);
    return s;
}

function Yn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Gn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Yn(e, n);
        }
    }
}

const Pc = t => t >= 23 || t === 4 || t === 5;

const Tc = new WeakMap;

const qc = Symbol();

const Mc = (t, n) => {
    if (!Array.isArray(n) || Bo(n) || (t => ke(t) && qc in t)(n)) {
        return n;
    }
    let e = Tc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new Ac(t, n));
        Tc.set(n, e);
    }
    return e;
};

class Ac {
    $;
    Me;
    constructor(t, n) {
        this.$ = t;
        this.Me = n;
    }
    get(t, n, e) {
        if (n === qc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Me.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Me[o];
        const i = this.Me[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Qu(c, r, i);
        Reflect.set(t, n, l);
        this.Me[o] = 0;
        this.Me[o + 1] = l;
        Pc(r) && kc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === qc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === qc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Me.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Me[i] = 0;
        this.Me[i + 1] = e;
        return !0;
    }
}

async function Kn(t) {
    const n = Fu(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.It();
    return n.Nt.toString();
}

function Zn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = ne(n);
    return Qn(e, n[0], n[1]);
}

function te(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ne(t) {
    let n;
    const e = {
        _: t => te(t, n),
        Ct: t => e.Rt?.[+t],
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        Rt: null
    };
    On(t, e);
    n = Mc(e, t);
    e.Ot = n;
    return e;
}

const xc = (t, n) => {
    const e = new WeakSet;
    return cf(Ic, t, e, "_", n);
};

const Ic = (t, n, e, s) => {
    const o = _u(t);
    if (o == null) {
        return t;
    }
    if (Cc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (lu(o)) {
            return t;
        }
        if (Du(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Ps(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Re(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw qe(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw qe(3, [ o ]);
                    }
                    Ic(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Pr) {
                return t;
            }
            if (Se(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Ic(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw qe(3, [ i ]);
    }
    return t;
};

const Nc = /*#__PURE__*/ new WeakSet;

const Cc = t => {
    if (ke(t) || Te(t)) {
        return !Nc.has(t) && !(Lc in t);
    }
    return !0;
};

const Oc = t => !!t && (ke(t) || typeof t === "function") && (Nc.has(t) || Lc in t);

const jc = t => {
    (ke(t) && t !== null || typeof t === "function") && Nc.add(t);
    return t;
};

const Lc = Symbol();

const Fc = Symbol();

const Xc = t => /*#__PURE__*/ Object.freeze({
    id: Os(t)
});

const Dc = (t, n) => {
    const {val: e, set: s, iCtx: o} = vo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Wc = (t, n) => {
    const {val: e, set: s, iCtx: o} = vo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(ce(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw qe(8, [ t.id ]);
};

const Vc = t => {
    const n = of();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Uc = /*#__PURE__*/ Xc("qk-error");

const Ch = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Oh = new WeakMap;

class jh {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Lh(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Ch(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Lh = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Fh = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = rf()?.$;
    return t?.outOfOrderStreaming === !0 && !Ah(t);
};

const zc = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && hu(t, n, r);
};

const Bc = new WeakMap;

const Hc = (t, n) => {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`${Qc(e.Te)}${Ve}`);
    const o = Jc(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(Ph) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        Yc(t, e, i.textContent);
    }
};

const Jc = t => {
    let n = Bc.get(t);
    if (!n) {
        n = new WeakSet;
        Bc.set(t, n);
    }
    return n;
};

const Qc = t => `script[type="qwik/state"][q\\:instance="${t}"]`;

const Yc = (t, n, e) => {
    if (e) {
        const [s, o, r, i] = JSON.parse(e);
        Gc(t, n, s, o);
        Kc(n, r || void 0);
        ((t, n) => {
            if (!__EXPERIMENTAL__.suspense || !n) {
                return;
            }
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                const o = t._(s.rootId);
                const r = s.subscriptions;
                if (o instanceof zr) {
                    r instanceof Set && zc(t, o, o, o.ct ||= new Set, r);
                } else {
                    if (!(r instanceof Map)) {
                        continue;
                    }
                    const n = mu(o);
                    const e = wu(o);
                    if (!n || !e) {
                        continue;
                    }
                    const s = n.ct ||= new Map;
                    for (const [o, i] of r) {
                        let r = s.get(o);
                        if (!r) {
                            r = new Set;
                            s.set(o, r);
                        }
                        zc(t, n, e, r, i);
                    }
                }
            }
        })(t, i === void 0 ? void 0 : n._(i));
    }
};

const Gc = (t, n, e, s) => {
    const o = n.Ae.length / 2;
    if (e !== o) {
        return;
    }
    for (let t = 0; t < s.length; t++) {
        n.Ae[e * 2 + t] = s[t];
    }
    On(n.Ae, t, 0, e * 2);
    n.xe = Mc(t, n.Ae);
    n.xe.length = n.Ae.length / 2;
    n.Ie = n.Rt;
};

const Kc = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Ie ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Rt = e;
};

function ee(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = t => {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && w(s);
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = (n, e, s, o, r, i, c, l) => {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Zc(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && v(t.createTreeWalker(e, 129), null, e, null, "", null, null);
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = tf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? je(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Oe || n.charCodeAt(1) !== Oe || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
        } while (s = S || n.nextNode());
    };
    const g = (n, e, s, o) => {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = __EXPERIMENTAL__.suspense ? (t, n, e, s) => {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && g(t, n, s, e);
    } : null;
    h.qProcessVNodeDataPatch = t => {
        const n = t?.closest("[q\\:container]");
        const e = t?.getAttribute("q:r");
        const s = n && (e ? n.querySelector(`[q\\:rp="${e}"]`) : n);
        n && s && g(n, s, t.textContent, e || void 0);
    };
    if (__EXPERIMENTAL__.suspense && n !== void 0) {
        if (e && s && o) {
            e.qVNodeRefs ||= new Map;
            E(e, s, n, o);
        }
        return;
    }
    w(t);
    const S = t.createTreeWalker(t, 129);
    v(S, null, S.firstChild(), null, "", null, null);
}

const Zc = t => 33 <= t && t <= 46;

const tf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Zc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function se(t) {
    const n = ie(t);
    if (!n) {
        throw qe(24);
    }
    return re(n);
}

function re(t) {
    const n = t;
    return n.qContainer ||= new nf(n);
}

function ie(t) {
    return t.closest(os);
}

function oe(t, n) {
    const e = t + "";
    const s = n?.closest(os);
    const o = s?.qContainer;
    if (o) {
        (function t(n, e, s) {
            if (!__EXPERIMENTAL__.suspense || !s) {
                return;
            }
            const o = s.closest("[q\\:container]");
            const r = o?.querySelector(`script[type="qwik/vnode"][q\\:r="${e}"]:not([q\\:patch])`);
            ee(n, e, o, s, r?.textContent || void 0);
            const i = o?.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${e}"][q\\:patch]`);
            for (let t = 0; i && t < i.length; t++) {
                n.qProcessVNodeDataPatch?.(i[t]);
            }
        })(o.element.ownerDocument, e, n);
        Hc(o, e);
    }
}

class nf extends lc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    Ne;
    Te;
    Rt=null;
    vNodeLocate=t => ll(this.rootVNode, t);
    Ae;
    xe;
    Ie=null;
    Ce=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(es);
        if (!this.qContainer) {
            throw qe(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.qe = t.getAttribute(Ge);
        this.Te = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Vo(this.element);
        this.Ae = [];
        this.xe = [];
        const n = this.element.ownerDocument;
        n.qVNodeDataProcessed || function e(t) {
            ee(t);
            t.qVNodeDataProcessed = !0;
        }(n);
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= oe);
        this.Ne = Ye(n, this.Te) || ei;
        this.Oe();
        t.setAttribute(es, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.Tn();
        this.je();
        __EXPERIMENTAL__.suspense && Hc(this);
        this.Le();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Tn() {
        this.vNodeLocate = () => null;
        this.Ae.length = 0;
        this.xe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(es);
        const n = t.ownerDocument;
        const e = n.querySelector(os) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    je() {
        const t = this.element.querySelector(`${this.Fe()}:not(${Ve})`);
        if (t) {
            this.Ae = JSON.parse(t.textContent);
            On(this.Ae, this);
            this.Ie = this.Rt;
            this.xe = Mc(this, this.Ae);
        }
    }
    Fe() {
        return `script[type="qwik/state"][q\\:instance="${this.Te}"]`;
    }
    Le() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Be);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    xn(t, n) {
        this.xe[t] = n;
    }
    parseQRL(t) {
        const n = Nn(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, Uc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Je);
        s == null && this.setHostProp(t, Je, s = []);
        _e(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Je);
            if (e != null && Ee(e, n.id, 0)) {
                return ge(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Go(n)) {
                if (Zo(n, Le, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        tl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case ps:
          case ds:
          case Le:
          case Je:
          case Qe:
          case rs:
            s = this._;
            break;

          case $s:
          case vs:
            s = parseInt;
            break;
        }
        return Zo(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => te(t, this.xe);
    Ct(t) {
        return this.Ie?.[t];
    }
    getSyncFn(t) {
        const n = this.Ne[t];
        return n;
    }
    Xe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, He);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, He, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ce == null) {
            this.Ce = new Set;
            const t = this.document.querySelectorAll(ze);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ce.add(e.getAttribute(Ue));
            }
        }
        if (!this.Ce.has(n)) {
            this.Ce.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Ue, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Oe() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Es) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Dt = {
            containerAttributes: t
        };
    }
}

let ef;

let Xh;

if ($e) {
    const t = ic();
    t && (Xh = new t);
}

function le(t) {
    if (Xh) {
        const t = Xh.getStore();
        if (t) {
            return t;
        }
    }
    if (ef === void 0) {
        const n = rf();
        if (n && n.jt) {
            return n.jt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return ef;
}

function ue(t, n) {
    if (Xh) {
        return Xh.run(t, n);
    }
    const e = ef;
    try {
        ef = t;
        return n();
    } finally {
        ef = e;
    }
}

let sf;

const rf = () => sf;

const of = () => {
    const t = rf();
    if (!t) {
        throw qe(9);
    }
    return t;
};

const lf = () => {
    const t = rf();
    if (!t || t.Lt !== fs) {
        throw qe(10);
    }
    return t;
};

function ce(t, n, ...e) {
    return fe.call(this, t, n, e);
}

function fe(t, n, e) {
    const s = sf;
    try {
        sf = t;
        return n.apply(this, e);
    } finally {
        sf = s;
    }
}

const uf = (t, n) => {
    const e = se(n);
    const s = ll(e.rootVNode, n);
    const o = e.jt;
    o && function r(t) {
        if (Xh) {
            Xh.enterWith(t);
            return;
        }
        ef = t;
    }(o);
    const i = he(o, s, t);
    i.$ = e;
    return i;
};

function ae(t, n, e) {
    const s = {
        m: n,
        Lt: fs,
        Ft: void 0,
        jt: t,
        $: e,
        Xt: void 0
    };
    return s;
}

function he(t, n, e) {
    const s = t || (e && ke(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        Lt: e,
        Ft: void 0,
        jt: s,
        $: void 0
    };
    return o;
}

const cf = (t, ...n) => {
    if (typeof t === "function") {
        if (!sf) {
            return t(...n);
        }
        {
            const e = sf.Ft;
            try {
                sf.Ft = void 0;
                return t(...n);
            } finally {
                sf.Ft = e;
            }
        }
    }
    if (lu(t)) {
        return t.untrackedValue;
    }
    return _u(t);
};

const ff = /*#__PURE__*/ ae(void 0, void 0, void 0);

const af = (t, n, e, s, o) => {
    const r = ff.Ft;
    const i = ff.$;
    try {
        ff.Ft = m(n, e, o);
        ff.$ = s;
        return fe(ff, t);
    } finally {
        ff.Ft = r;
        ff.$ = i;
    }
};

const hf = (t, n, e, s, o) => {
    t instanceof Pi && t.m !== n && n && (t.m = n);
    return af(() => t.value, n, e, s, o);
};

const df = () => rf()?.m;

const pf = () => {
    const t = rf();
    if (t) {
        return t.Lt;
    }
};

const $f = () => {
    const t = rf();
    if (t) {
        return t.$;
    }
};

const yf = t => t;

const mf = t => t.l || Promise.resolve();

let wf = (t, n, e, s, o) => new bf(t, n, e, s, o);

class bf {
    _t;
    vt;
    De;
    We;
    $;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.vt = n;
        this.De = e;
        this.We = s;
        s && this.Ve(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ye && t && pe(t, .8);
    }
    get it() {
        return Rh(this.vt);
    }
    Ve(t) {
        this.We = t;
        Ps(t) && t.then(t => this.We = t, t => {
            console.error(`qrl ${this.vt} failed to load`, t);
            this.We = null;
        });
    }
    Ue() {
        if (this.We != null) {
            return this.We;
        }
        if (this._t === "") {
            const t = this.$.Te;
            const n = this.$.element?.ownerDocument || document;
            const e = Ye(n, t);
            return this.We = e[+this.vt];
        }
        ye && this._t && pe(this._t, 1);
        const t = this.vt;
        const n = this.De ? this.De().then(n => n[t]) : Js().importSymbol(this.$?.element, this._t, t);
        this.Ve(n);
        return this.We;
    }
}

ye && import.meta.hot && (t => {
    if (!ye || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        wf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.De?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.De = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.vt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.vt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.We = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(bf);

const vf = Symbol();

const _f = t => t?.[vf] ?? t;

class gf {
    ze;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ze = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.We == null || typeof this.Mt === "string" || Ps(t.We) || (this.resolved = Mf(this, t.We));
    }
}

const Ef = function(t, ...n) {
    const e = _f(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = rf();
    return Sf.call(e, s?.$).then(() => fe.call(t, s, e.resolved, n));
};

const Sf = async function(t) {
    const n = _f(this);
    return qs(Af(n, t), () => n.resolved);
};

const kf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[vf].resolved;
        },
        set(t) {
            this[vf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[vf].Mt;
        },
        set(t) {
            this[vf].Mt = t;
        }
    },
    $: {
        get() {
            return this[vf].$;
        },
        set(t) {
            this[vf].$ = t;
        }
    },
    ze: {
        get() {
            return this[vf].ze;
        }
    },
    _t: {
        get() {
            return this[vf].ze._t;
        }
    },
    vt: {
        get() {
            return this[vf].ze.vt;
        }
    },
    it: {
        get() {
            return this[vf].ze.it;
        }
    },
    dev: {
        get() {
            return this[vf].ze.dev;
        }
    },
    Be: {
        value: Ef
    },
    w: {
        value: function(t) {
            const n = _f(this);
            const e = new gf(n.ze, t, n.Mt ? n.$ : void 0);
            return If(e);
        }
    },
    s: {
        value: function(t) {
            const n = _f(this);
            n.ze.Ve(t);
            n.resolved = Mf(n, t);
        }
    },
    resolve: {
        value: Sf
    },
    getSymbol: {
        value: function() {
            return _f(this).ze.vt;
        }
    },
    getHash: {
        value: function() {
            return _f(this).ze.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = _f(this);
            qf(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = _f(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Sf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return fe(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Rf = null;

const Pf = t => {
    Rf = t;
};

const Tf = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const qf = t => {
    Rf = t.Mt;
    const n = t.$;
    if (typeof Rf === "string") {
        if (!n) {
            throw qe(13);
        }
        const e = gc;
        Rf = t.Mt = Tf(n, Rf);
        if (gc !== e) {
            return gc;
        }
    }
};

const Mf = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        qf(t);
        return n.apply(this, s);
    };
};

const Af = (t, n) => {
    const e = t.ze;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || rf()?.$);
    if (t.resolved) {
        return;
    }
    const o = jf();
    const r = rf();
    const i = e.Ue();
    const c = qs(i, n => {
        t.resolved = Mf(t, n);
    });
    if (c) {
        const t = e.vt;
        Cf(t, r?.m instanceof qr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && qf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const xf = (t, n, e, s, o, r) => {
    const i = wf(t, n, s, e, r);
    const c = new gf(i, o, r);
    return If(c);
};

const If = t => {
    const n = async function(...t) {
        return Ef.call(n, this, ...t);
    };
    n[vf] = t;
    Object.setPrototypeOf(n, kf);
    return n;
};

const Nf = /*#__PURE__*/ new Set;

const Cf = (t, n, e) => {
    if (!Nf.has(t)) {
        Nf.add(t);
        Of("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Of = (t, n) => {
    qh() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const jf = () => {
    if (qh()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Lf = 0;

const Ff = t => xf(null, "s" + Lf++, t, null, null);

const Xf = Ff;

const Df = t => t;

const Wf = t => xf("", Me, t, null, null);

const Vf = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return xf("", Me, t, null, null);
};

const Uf = t => {
    function n(n, e, s = 0) {
        const o = t.it.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[zf] = [ t ];
        return Wi(i, n, null, n.children, s, r);
    }
    n[zf] = [ t ];
    return n;
};

const zf = Symbol();

const Bf = t => typeof t == "function" && t[zf] !== void 0;

const Hf = t => Uf(Xf(t));

const Jf = hi(Df);

const Qf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Yf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !vr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(es, "resumed");
    const s = se(t);
    s.Dt = e.serverData || {};
    const o = s.rootVNode;
    tl(o, Cr, n);
    hn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const Gf = (t, n) => {
    const {val: e, set: s, iCtx: o} = vo();
    if (e != null) {
        return e;
    }
    const r = Te(t) ? ce(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Eu(r, i, t);
        s(c);
        return c;
    }
};

const Kf = () => {
    const {val: t, set: n, iCtx: e} = vo();
    if (t != null) {
        return t;
    }
    const s = e.$.qe || "";
    const o = s ? Fs(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Le);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Re;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Pe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function de(t, n) {
    const e = rf();
    return e?.$?.Dt[t] ?? n;
}

const Zf = /*#__PURE__*/ new Map;

const ta = (t, n) => {
    let e = Zf.get(n);
    e || Zf.set(n, e = na(t, n));
    return e;
};

const na = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = oa;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Ia) {
            r++;
            e = Ma;
        }
        const s = Da[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === $a || $ === ya && ea(l) || $ === wa && ia(l)) && (y === e || y === $a || y === ya && ea(e) || y === ma && !ea(e) && e !== Ra || y === wa && ia(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === da || m == pa) {
                    if (m === pa) {
                        if (c !== la || h()) {
                            if (!sa(e)) {
                                const t = y == ma ? 1 : y == Sa ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            sa(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === ma) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || oa;
                        if (c === ua) {
                            u(r - 1);
                            i++;
                        }
                    } while (ra(c));
                } else {
                    o.push(c);
                    if (c === ua && m === oa) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === ca && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === ua || h()) {
            return;
        }
        u(t);
        s.push(".", Xe, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === ka) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === ka) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Ca) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(ua) !== -1 || o.indexOf(fa) !== -1;
    }
};

const ea = t => t >= Pa && t <= Ta || t >= Ma && t <= Aa || t >= Oa && t <= ja || t >= 128 || t === Na || t === ka;

const sa = t => t === qa || t === Ra || t === xa || t === Ea || ea(t);

const ra = t => t === aa || t === fa || t === ha || t === ua;

const ia = t => t === ga || t === ba || t === va || t === _a;

const oa = 0;

const la = 2;

const ua = 5;

const ca = 6;

const fa = 10;

const aa = 11;

const ha = 12;

const da = 17;

const pa = 18;

const $a = 0;

const ya = 1;

const ma = 2;

const wa = 3;

const ba = 9;

const va = 10;

const _a = 13;

const ga = 32;

const Ea = 35;

const Sa = 41;

const ka = 45;

const Ra = 46;

const Pa = 48;

const Ta = 57;

const qa = 58;

const Ma = 65;

const Aa = 90;

const xa = 91;

const Ia = 92;

const Na = 95;

const Ca = 32;

const Oa = 97;

const ja = 122;

const La = 123;

const Fa = 125;

const Xa = /*@__PURE__*/ (() => [ [ $a, 39, 14 ], [ $a, 34, 15 ], [ $a, 47, 16, "*" ] ])();

const Da = /*@__PURE__*/ (() => [ [ [ $a, 42, la ], [ $a, xa, 7 ], [ $a, qa, ca, ":", "before", "after", "first-letter", "first-line" ], [ $a, qa, ua, "global" ], [ $a, qa, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ $a, qa, 4 ], [ $a, ya, 1 ], [ $a, Ra, 1 ], [ $a, Ea, 1 ], [ $a, 64, fa, "keyframe" ], [ $a, 64, aa, "media", "supports", "container" ], [ $a, 64, ha ], [ $a, La, 13 ], [ 47, 42, 16 ], [ $a, 59, da ], [ $a, Fa, da ], [ $a, Sa, da ], ...Xa ], [ [ $a, ma, pa ] ], [ [ $a, ma, pa ] ], [ [ $a, 40, oa ], [ $a, ma, pa ] ], [ [ $a, 40, 8 ], [ $a, ma, pa ] ], [ [ $a, 40, oa ], [ $a, ma, da ] ], [ [ $a, ma, da ] ], [ [ $a, 93, pa ], [ $a, 39, 14 ], [ $a, 34, 15 ] ], [ [ $a, Sa, da ], ...Xa ], [ [ $a, Fa, da ], ...Xa ], [ [ $a, Fa, da ], [ wa, ya, 1 ], [ $a, qa, ua, "global" ], [ $a, La, 13 ], ...Xa ], [ [ $a, La, oa ], [ $a, 59, da ], ...Xa ], [ [ $a, 59, da ], [ $a, La, 9 ], ...Xa ], [ [ $a, Fa, da ], [ $a, La, 13 ], [ $a, 40, 8 ], ...Xa ], [ [ $a, 39, da ] ], [ [ $a, 34, da ] ], [ [ 42, 47, da ] ] ])();

const Wa = t => ({
    styleId: Ba(t, t => t, !1)
});

const Va = /*#__PURE__*/ hi(Wa);

const Ua = t => ({
    scopeId: Xe + Ba(t, ta, !0)
});

const za = /*#__PURE__*/ hi(Ua);

const Ba = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = vo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Fs(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Xe(n(t, c), c, l, e));
    }
    r.$.Xe(n(t.resolved, c), c, l, e);
    return c;
};

const Ha = (t, n) => {
    t.resolve();
    return pi(t, n);
};

const Ja = (t, n) => Eo(Ha, t, n);

const Qa = hi(Ja);

const Ya = t => {
    t.resolve();
    return yi(t);
};

const Ga = t => Eo(Ya, t);

const Ka = hi(Ga);

const Za = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = vo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !qh()) {
            e.h |= 32;
            th(e, i);
        }
        return;
    }
    let c;
    if (qh()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        hn(r.$, r.m, 1);
    }
    const l = new ru(c, o, r.m, t, void 0, null);
    s(l);
    th(l, i);
};

const th = (t, n) => {
    n === "intersection-observer" ? $c("qvisible", nh(t)) : n === "document-ready" ? yc("qinit", nh(t)) : n === "document-idle" && yc("qidle", nh(t));
};

const nh = t => xf(null, "_task", Rn, null, [ t ]);

const eh = hi(hc);

const sh = /*#__PURE__*/ hi(eu);

const rh = /*#__PURE__*/ hi(Za);

const ih = (t, n) => {
    t.resolve();
    return $i(t, n);
};

const oh = (t, n) => Eo(ih, t, n);

const lh = hi(oh);

const uh = () => {
    const t = Gf({
        error: void 0
    });
    Dc(Uc, t);
    return t;
};

const ch = async ({track: t}) => {
    const n = Rf[0];
    t(() => n.items);
    const e = rf();
    const s = e.m;
    const o = e.$;
    hn(o, s, 256);
    const r = $e;
    r && await o.l;
};

const fh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    eu(/*#__PURE__*/ Gu(ch, "_eaT", [ t ]));
    return Zi;
};

const ah = /*#__PURE__*/ Uf(
/*#__PURE__*/ Gu(fh, "_eaC"));

const hh = /*#__PURE__*/ Xc("qk-reveal");

const dh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: mi(0)
});

const ph = () => {
    const t = Rf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ye) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Ch(t);
};

const $h = ({cleanup: t}) => {
    const n = Rf[0];
    t(() => {
        if (!ye) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const yh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Eo(dh, t);
    Dc(hh, n);
    const e = !ye;
    if (__EXPERIMENTAL__.suspense && e && Fh()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!Fh()) {
                    return null;
                }
                const e = rf()?.$;
                let s = 0;
                if (e) {
                    s = (Oh.get(e) || 0) + 1;
                    Oh.set(e, s);
                }
                return new jh(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = jc(e);
            return e;
        })(n);
        /*#__PURE__*/
        return Di(Dh, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return Di(Ki, null, null, null, 0, "u7_0");
};

const mh = /*#__PURE__*/ Uf(
/*#__PURE__*/ Gu(yh, "_reC"));

const Dh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Di(Ki, null, null, null, 0, "u7_0"));
}) : null;

const wh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Wh = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const bh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const vh = ({track: t, cleanup: n}) => {
    const e = Rf[0], s = Rf[1], o = Rf[2], r = Rf[3];
    const i = t(e.pending);
    const c = ye;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const _h = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = go("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return Eo(So);
    })();
    const s = (t => {
        const n = Wc(hh, null);
        const e = Eo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && eu(/*#__PURE__*/ Gu($h, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Ja(
    /*#__PURE__*/ Gu(ph, "_reR", [ s ]));
    eu(
    /*#__PURE__*/ Gu(vh, "_suT", [ e, t, n, s ]));
    const r = !ye;
    const i = r && Fh();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = rf()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && zh(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ oc(wh, [ t, n, o, s ], Wh) : null;
    const d = /*#__PURE__*/ oc(bh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ Di(Vh, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, Si(t, "fallback"), 1, null) : /*#__PURE__*/ Di("div", {
        style: oc(wh, [ t, n, o, s ], Wh)
    }, null, Si(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ Di("div", null, i ? {
        [Th]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ Di(i ? Uh : Ki, i ? {
        [rs]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [rs]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const gh = /*#__PURE__*/ Uf(
/*#__PURE__*/ Gu(_h, "_suC"));

const Vh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !zh(r) ? l.value = "fallback" : o && c && zh(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ Di("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const Uh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Nh(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return Di(Ki, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return Di(Ki, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${Ph}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${Ph}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function zh(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const Eh = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Sh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Di("script", null, o, null, 0, "prefetch-service-worker");
};

const Sh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const kh = () => null;

globalThis.__qwik && qe(30, [ globalThis.__qwik, br ]);

globalThis.__qwik = br;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Ff as $, ah as Each, Yi as Fragment, Lc as NoSerializeSymbol, kh as PrefetchGraph, Eh as PrefetchServiceWorker, Gi as RenderOnce, dc as Resource, mh as Reveal, no as SSRComment, to as SSRRaw, so as SSRStream, eo as SSRStreamBlock, Fc as SerializerSymbol, Zi as SkipRender, Ki as Slot, gh as Suspense, Yr as _CONST_PROPS, nf as _DomContainer, _r as _EFFECT_BACK_REF, ps as _ELEMENT_SEQ, ei as _EMPTY_ARRAY, si as _EMPTY_OBJ, ti as _IMMUTABLE, lc as _SharedContainer, Ti as _SubscriptionData, qu as _SubscriptionPatch, ru as _Task, ni as _UNINITIALIZED, Gr as _VAR_PROPS, zn as _addProjection, Rf as _captures, v as _chk, ne as _createDeserializeContainer, xf as _createQRL, Tn as _createStore, Ms as _delay, Zn as _deserialize, Uu as _dumpState, fh as _eaC, ch as _eaT, fn as _executeSsrChores, oc as _fnSignal, ic as _getAsyncLocalStorage, fi as _getConstProps, $f as _getContextContainer, pf as _getContextEvent, df as _getContextHostElement, se as _getDomContainer, ie as _getQContainerElement, m as _getSubscriber, ci as _getVarProps, vu as _hasStoreEffects, vc as _hmr, Qr as _injectAsyncSignalValue, ce as _invoke, Ai as _isJSXNode, gu as _isStore, Ln as _isStringifiable, iu as _isTask, yf as _jsxBranch, Vi as _jsxC, zi as _jsxQ, Ui as _jsxS, Di as _jsxSorted, Wi as _jsxSplit, ve as _mapApp_findIndx, ge as _mapArray_get, _e as _mapArray_set, he as _newInvokeContext, Ku as _noopQrl, Zu as _noopQrlDEV, On as _preprocessState, Vf as _qrlSync, xn as _qrlToString, tc as _qrlWithChunk, nc as _qrlWithChunkDEV, yh as _reC, ph as _reR, $h as _reT, rc as _regSymbol, Jn as _removeProjection, _ as _res, Vc as _resolveContextWithoutSequentialScope, uo as _restProps, n as _retryOnPromise, ac as _rsc, I as _run, Kn as _serialize, Wn as _setEvent, Bn as _setProjectionTarget, _h as _suC, vh as _suT, Rn as _task, Hn as _updateProjectionProps, Un as _useHmr, b as _val, xc as _verifySerializable, sl as _vnode_ensureElementInflated, Bl as _vnode_getAttrKeys, kl as _vnode_getElementName, Tl as _vnode_getFirstChild, Zo as _vnode_getProp, fl as _vnode_getVNodeForChildNode, vl as _vnode_insertBefore, Ho as _vnode_isElementVNode, Qo as _vnode_isMaterialized, Yo as _vnode_isTextVNode, Go as _vnode_isVirtualVNode, zo as _vnode_newVirtual, El as _vnode_remove, tl as _vnode_setProp, bn as _vnode_toString, mf as _waitUntilRendered, Xn as _walkJSX, Si as _wrapProp, Ri as _wrapSignal, Hf as component$, Uf as componentQrl, bi as createAsync$, $i as createAsyncQrl, wi as createComputed$, pi as createComputedQrl, Xc as createContextId, g as createElement, vi as createSerializer$, yi as createSerializerQrl, mi as createSignal, Jf as event$, Df as eventQrl, bu as forceStoreEffects, Qf as getClientManifest, se as getDomContainer, le as getLocale, Js as getPlatform, g as h, hi as implicit$FirstArg, Gu as inlinedQrl, sc as inlinedQrlDEV, me as isDev, lu as isSignal, Hi as jsx, Ji as jsxDEV, Qi as jsxs, jc as noSerialize, Yu as qrl, ec as qrlDEV, Yf as render, Hs as setPlatform, Wf as sync$, cf as untrack, _u as unwrapStore, lh as useAsync$, oh as useAsyncQrl, Qa as useComputed$, Ja as useComputedQrl, Eo as useConstant, Wc as useContext, Dc as useContextProvider, uh as useErrorBoundary, Kf as useId, fc as useLexicalScope, $c as useOn, yc as useOnDocument, mc as useOnWindow, eh as useResource$, hc as useResourceQrl, Ka as useSerializer$, Ga as useSerializerQrl, de as useServerData, go as useSignal, Gf as useStore, Va as useStyles$, Wa as useStylesQrl, za as useStylesScoped$, Ua as useStylesScopedQrl, sh as useTask$, eu as useTaskQrl, rh as useVisibleTask$, Za as useVisibleTaskQrl, br as version, ue as withLocale };
